(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[25],{

/***/ "0x+k":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE1IDE1Ij4KICA8ZyBpZD0iYXJyb3dfc2hvcHBpbmctY2FydCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE0NDcgLTIwNSkiPgogICAgPHBhdGggaWQ9IlBhdGhfMTgyMSIgZGF0YS1uYW1lPSJQYXRoIDE4MjEiIGQ9Ik0tMjA2NjQtNTY0Ni45di01aDUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyMDY5LjY1NiAxODgxOC42NTIpIHJvdGF0ZSg0NSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzIxMjIyMiIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfMzM3MyIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMzM3MyIgd2lkdGg9IjE1IiBoZWlnaHQ9IjE1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDQ3IDIwNSkiIGZpbGw9Im5vbmUiLz4KICA8L2c+Cjwvc3ZnPgo=" };

/***/ }),

/***/ "2CxJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ZD0w");
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_lingui_react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("vOnD");
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("/MKj");
/* harmony import */ var components_atoms_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("wCgk");
/* harmony import */ var data_abstractProducts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("eTmy");
/* harmony import */ var data_abstractProducts__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(data_abstractProducts__WEBPACK_IMPORTED_MODULE_5__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;







var SubTitle = function SubTitle(_ref) {
  var handle = _ref.handle,
      className = _ref.className;
  var regionId = Object(react_redux__WEBPACK_IMPORTED_MODULE_3__[/* useSelector */ "d"])(function (state) {
    return state.settings.regionId;
  });
  var abstractProduct = data_abstractProducts__WEBPACK_IMPORTED_MODULE_5___default.a.byId[handle];
  var shippingNoticeRegion = [];
  var shippingText;

  if (abstractProduct && abstractProduct.shippingTextByRegion) {
    shippingText = abstractProduct.shippingTextByRegion[regionId];

    if (!shippingText) {
      shippingText = abstractProduct.shippingTextByRegion["default"];
    }
  }

  return shippingText && shippingNoticeRegion.includes(regionId) ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(StyledSubtitle, {
    className: className
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_lingui_react__WEBPACK_IMPORTED_MODULE_0__["Trans"], {
    id: shippingText
  })) : null;
};

var StyledSubtitle = Object(styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(components_atoms_Text__WEBPACK_IMPORTED_MODULE_4__[/* Subtitle */ "n"]).withConfig({
  displayName: "SubTitle__StyledSubtitle",
  componentId: "s6wieq-0"
})(["color:", ";font-weight:bold;"], function (props) {
  return props.theme.colors.primary;
});
SubTitle.defaultProps = {
  className: ''
};
/* harmony default export */ __webpack_exports__["a"] = (SubTitle);

/***/ }),

/***/ "2VYq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("1OyB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("vuIU");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("JX7q");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("Ji7U");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("md7G");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("foSv");

// EXTERNAL MODULE: ./actions/handleAddCartItem.js + 1 modules
var handleAddCartItem = __webpack_require__("2OoW");

// EXTERNAL MODULE: ./data/regions.js
var regions = __webpack_require__("keR7");
var regions_default = /*#__PURE__*/__webpack_require__.n(regions);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("Ff2n");

// EXTERNAL MODULE: ./node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__("ZD0w");

// EXTERNAL MODULE: ./components/atoms/Text/index.js + 17 modules
var Text = __webpack_require__("wCgk");

// CONCATENATED MODULE: ./components/shared/Cart/shared/UpsellExtraBattery/Component.js

var __jsx = react_default.a.createElement;




var UpsellExtraBattery = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Component__UpsellExtraBattery",
  componentId: "sc-6mo5mt-0"
})(["padding:", "px 0;background-color:", ";text-align:center;border-radius:", ";margin:", "px 0;@media ", "{padding:", "px 0;margin:", "px 0;}"], function (props) {
  return props.theme.baseline * 2;
}, function (props) {
  return props.theme.colors.grey3;
}, function (props) {
  return props.theme.sizes.radius;
}, function (props) {
  return props.theme.halfBaseline * 10;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.baseline * 4;
}, function (props) {
  return props.theme.halfBaseline * 10;
});
var TextWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Component__TextWrapper",
  componentId: "sc-6mo5mt-1"
})(["width:", "px;margin:auto;@media ", "{width:", "px;}"], function (props) {
  return props.theme.baseline * 30;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.baseline * 40;
});
var Component_Text = Object(styled_components_browser_esm["default"])(Text["j" /* MenuText */]).withConfig({
  displayName: "Component__Text",
  componentId: "sc-6mo5mt-2"
})(["text-transform:uppercase;margin-right:", "px;"], function (props) {
  return props.theme.halfBaseline;
});
var CTA = Object(styled_components_browser_esm["default"])(Component_Text).withConfig({
  displayName: "Component__CTA",
  componentId: "sc-6mo5mt-3"
})(["cursor:pointer;color:", ";display:contents;text-decoration:underline;"], function (props) {
  return props.theme.colors.primary;
});

var Component_Component = function Component(_ref) {
  var show = _ref.show,
      handleAddExtraBatteryClick = _ref.handleAddExtraBatteryClick,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["show", "handleAddExtraBatteryClick"]);

  return show && /*#__PURE__*/react_default.a.createElement(UpsellExtraBattery, {
    className: rest.className
  }, /*#__PURE__*/react_default.a.createElement(TextWrapper, null, /*#__PURE__*/react_default.a.createElement(Component_Text, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.cart.upsell.message.extra-battery"
  })), /*#__PURE__*/react_default.a.createElement(CTA, {
    onClick: handleAddExtraBatteryClick
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.cart.upsell.extra-battery"
  }))));
}; // PropTypes


/* harmony default export */ var UpsellExtraBattery_Component = (Component_Component);
// CONCATENATED MODULE: ./components/shared/Cart/shared/UpsellExtraBattery/Container.js







var Container_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var Container_ConnectedUpsellExtraBatteryContainer = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(ConnectedUpsellExtraBatteryContainer, _Component);

  var _super = _createSuper(ConnectedUpsellExtraBatteryContainer);

  /**
   * @constructor
   * @desc handleAddExtraBatteryClick: pass as prop to child component
   */
  function ConnectedUpsellExtraBatteryContainer(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ConnectedUpsellExtraBatteryContainer);

    _this = _super.call(this, props);
    _this.handleAddExtraBatteryClick = _this.handleAddExtraBatteryClick.bind(Object(assertThisInitialized["a" /* default */])(_this));
    return _this;
  }
  /**
   * @desc on ExtraBattery button click, dispatch redux action
   */


  Object(createClass["a" /* default */])(ConnectedUpsellExtraBatteryContainer, [{
    key: "handleAddExtraBatteryClick",
    value: function handleAddExtraBatteryClick() {
      var _this$props = this.props,
          addItemToCart = _this$props.addItemToCart,
          extraBatteryVariantId = _this$props.extraBatteryVariantId;
      addItemToCart(extraBatteryVariantId);
    }
    /**
     * @returns {JSX}
     */

  }, {
    key: "render",
    value: function render() {
      var rest = Object(esm_extends["a" /* default */])({}, this.props);

      return /*#__PURE__*/react_default.a.createElement(UpsellExtraBattery_Component, {
        handleAddExtraBatteryClick: this.handleAddExtraBatteryClick,
        show: rest.show,
        className: rest.className
      });
    }
  }]);

  return ConnectedUpsellExtraBatteryContainer;
}(react["Component"]); // PropTypes


Container_ConnectedUpsellExtraBatteryContainer.defaultProps = {
  extraBatteryVariantId: null
}; // PropTypes

var Container_mapStateToProps = function mapStateToProps(state) {
  var _state$entities = state.entities,
      cartItems = _state$entities.cartItems,
      variants = _state$entities.variants,
      products = _state$entities.products;
  var regionId = state.settings.regionId;
  var shopId = regions_default.a.byId[regionId].shopId;
  var variantId;
  var productId;
  var handle; // Check if ExtraBattery in cart

  var extraBatteryInCart = cartItems.allIds.find(function (cartItemId) {
    variantId = cartItems.byId[cartItemId].variantId;
    productId = variants.byId[variantId].productId;
    handle = products.byId[productId].handle;
    return handle === 'batteryboks';
  }); // Check if Soundboks Go or Gen 3 in cart

  var soundboksGen3AndGoInCart = cartItems.allIds.find(function (cartItemId) {
    variantId = cartItems.byId[cartItemId].variantId;
    productId = variants.byId[variantId].productId;
    handle = products.byId[productId].handle;
    return handle === 'soundboks-go' || handle === 'soundboks-gen-3';
  }); // Find backpack product id

  var extraBatteryId = products.allIds.find(function (id) {
    return products.byId[id].handle === 'batteryboks' && shopId === products.byId[id].shopId;
  }); // Get ExtraBattery variant id

  var extraBatteryVariantId = extraBatteryId ? products.byId[extraBatteryId].variantIds[0] : undefined; // Check availability

  var isInStock = variants.byId[extraBatteryVariantId] && variants.byId[extraBatteryVariantId].available; // If it's not in cart, if it exists and in stock, show ExtraBattery option

  var show = !!(!extraBatteryInCart && soundboksGen3AndGoInCart && extraBatteryVariantId && isInStock);
  return {
    show: show,
    extraBatteryVariantId: extraBatteryVariantId
  };
}; // mapDispatchToProps


var Container_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    addItemToCart: function addItemToCart(variantId) {
      dispatch(Object(handleAddCartItem["a" /* default */])(variantId, 1));
    }
  };
}; // Connect


var UpsellExtraBatteryContainer = Object(es["b" /* connect */])(Container_mapStateToProps, Container_mapDispatchToProps)(Container_ConnectedUpsellExtraBatteryContainer);
/* harmony default export */ var Container = (UpsellExtraBatteryContainer);
// CONCATENATED MODULE: ./components/shared/Cart/shared/UpsellExtraBattery/index.js

/* harmony default export */ var shared_UpsellExtraBattery = (Container);
// EXTERNAL MODULE: ./utils/product/getProductImages.js
var getProductImages = __webpack_require__("NgCz");

// EXTERNAL MODULE: ./data/shops.js
var shops = __webpack_require__("z1id");
var shops_default = /*#__PURE__*/__webpack_require__.n(shops);

// EXTERNAL MODULE: ./utils/convertToCurrency.js
var convertToCurrency = __webpack_require__("+YIU");

// EXTERNAL MODULE: ./actions/handleRemoveCartItem.js + 1 modules
var handleRemoveCartItem = __webpack_require__("Oq7K");

// EXTERNAL MODULE: ./components/shared/Cart/shared/ProductQuantity/index.js + 4 modules
var ProductQuantity = __webpack_require__("H9RR");

// EXTERNAL MODULE: ./components/shared/Cart/shared/RemoveCartItem/index.js
var RemoveCartItem = __webpack_require__("AfKe");

// EXTERNAL MODULE: ./components/atoms/Link/index.tsx
var Link = __webpack_require__("ZT91");

// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/CartItem/ProductImage/index.js
var ProductImage_jsx = react_default.a.createElement;


 // ProductImage

var ProductImage_ProductImage = function ProductImage(_ref) {
  var title = _ref.title,
      link = _ref.link,
      imageUrl = _ref.imageUrl;
  return /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: link.href,
    as: link.as,
    passHref: true
  }, /*#__PURE__*/react_default.a.createElement(ImageWrapper, null, /*#__PURE__*/react_default.a.createElement("img", {
    src: "".concat(imageUrl, "?height=120"),
    alt: title
  })));
};

var ImageWrapper = styled_components_browser_esm["default"].a.withConfig({
  displayName: "ProductImage__ImageWrapper",
  componentId: "sc-1to1h86-0"
})(["display:flex;float:left;margin-right:", "px;img{align-self:center;width:70px;height:70px;}@media ", "{margin-right:", "px;}"], function (props) {
  return props.theme.halfBaseline * 3;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.baseline * 2;
}); // PropTypes

/* harmony default export */ var CartItem_ProductImage = (ProductImage_ProductImage);
// EXTERNAL MODULE: ./utils/hooks/useGetDynamicVariants.ts + 2 modules
var useGetDynamicVariants = __webpack_require__("3f9c");

// EXTERNAL MODULE: ./components/shared/Cart/shared/SubTitle/index.js
var SubTitle = __webpack_require__("2CxJ");

// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/CartItem/Description/ProductName.js
var ProductName_jsx = react_default.a.createElement;






var ProductName_ProductName = function ProductName(_ref) {
  var handle = _ref.handle,
      link = _ref.link,
      title = _ref.title;
  return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(SubTitle["a" /* default */], {
    handle: handle
  }), /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: link.href,
    as: link.as,
    passHref: true
  }, /*#__PURE__*/react_default.a.createElement(ProductNameText, {
    as: "a"
  }, title)));
};

var ProductNameText = Object(styled_components_browser_esm["default"])(Text["j" /* MenuText */]).withConfig({
  displayName: "ProductName__ProductNameText",
  componentId: "sc-1xzaugo-0"
})(["text-transform:inherit;width:100%;margin-bottom:", "px;"], function (props) {
  return props.theme.halfBaseline * 3;
}); // propTypes

/* harmony default export */ var Description_ProductName = (ProductName_ProductName);
// EXTERNAL MODULE: ./components/pages/Products/Product/ProductPrice/index.js + 2 modules
var ProductPrice = __webpack_require__("dOrG");

// EXTERNAL MODULE: ./components/atoms/Text/mixins/bodyTextMixins.js
var bodyTextMixins = __webpack_require__("hcoH");

// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/CartItem/Description/ProductPrice.js



var ProductPrice_ProductPrice = Object(styled_components_browser_esm["default"])(ProductPrice["a" /* default */]).withConfig({
  displayName: "ProductPrice",
  componentId: "sc-4wsrok-0"
})(["width:100%;margin-top:16px;justify-content:flex-start;", ";font-weight:bold;> div{margin-right:", "px;}> div:last-child{font-weight:normal;}"], bodyTextMixins["d" /* bodyTextMixin4 */], function (props) {
  return props.theme.baseline;
});
/* harmony default export */ var Description_ProductPrice = (ProductPrice_ProductPrice);
// EXTERNAL MODULE: ./components/shared/Cart/shared/ProductOptions/index.js + 4 modules
var ProductOptions = __webpack_require__("HOtW");

// EXTERNAL MODULE: ./styles/theme.js
var theme = __webpack_require__("NVT0");

// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/CartItem/Description/ProductOptions.js



var ProductOptions_ProductOptions = Object(styled_components_browser_esm["default"])(ProductOptions["a" /* default */]).withConfig({
  displayName: "ProductOptions",
  componentId: "sc-1xbqlfg-0"
})(["height:", "px;width:99%;margin:", "px 0;max-width:", "px;&:after{background-size:contain;height:14px;width:14px;top:", "px;right:2px;}select{float:left;text-transform:uppercase;font-weight:bold;}@media ", "{max-width:", "px;height:", "px;margin:", "px 0;&:after{top:", "px;}}@media ", "{margin:", "px 0;}@media ", "{margin:", "px 0;}"], theme["a" /* default */].baseline * 3, theme["a" /* default */].baseline, theme["a" /* default */].baseline * 20, theme["a" /* default */].halfBaseline, theme["a" /* default */].breakpoints.tablet, theme["a" /* default */].baseline * 25, theme["a" /* default */].baseline * 4, theme["a" /* default */].halfBaseline, theme["a" /* default */].baseline, theme["a" /* default */].breakpoints.desktopLarge, theme["a" /* default */].halfBaseline * 2, theme["a" /* default */].breakpoints.desktopLarge, theme["a" /* default */].halfBaseline * 3);
/* harmony default export */ var Description_ProductOptions = (ProductOptions_ProductOptions);
// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/CartItem/Description/index.js
var Description_jsx = react_default.a.createElement;









var Description_Description = function Description(_ref) {
  var _dynamicVariants$byId, _dynamicVariants$byId2;

  var cartItemId = _ref.cartItemId,
      quantity = _ref.quantity,
      variantIds = _ref.variantIds,
      optionIds = _ref.optionIds,
      title = _ref.title,
      link = _ref.link,
      handle = _ref.handle;
  var cartItems = Object(es["d" /* useSelector */])(function (state) {
    return state.entities.cartItems;
  });
  var regionId = Object(es["d" /* useSelector */])(function (state) {
    return state.settings.regionId;
  });
  var cartItem = cartItems.byId[cartItemId];
  var shopId = regions_default.a.byId[regionId].shopId; // Dynamically getting the variants through hook

  var dynamicVariants = Object(useGetDynamicVariants["a" /* default */])(variantIds, shopId);
  var variantPrice = (_dynamicVariants$byId = dynamicVariants.byId[cartItem.variantId]) === null || _dynamicVariants$byId === void 0 ? void 0 : _dynamicVariants$byId.price;
  var variantcompareAtPrice = (_dynamicVariants$byId2 = dynamicVariants.byId[cartItem.variantId]) === null || _dynamicVariants$byId2 === void 0 ? void 0 : _dynamicVariants$byId2.compareAtPrice;
  return /*#__PURE__*/react_default.a.createElement(Wrapper, null, /*#__PURE__*/react_default.a.createElement(Description_ProductName, {
    handle: handle,
    link: link,
    title: title
  }), /*#__PURE__*/react_default.a.createElement(Description_ProductOptions, {
    cartItemId: cartItemId,
    variantIds: variantIds,
    optionIds: optionIds
  }), /*#__PURE__*/react_default.a.createElement(Description_ProductPrice, {
    cartItemId: cartItemId,
    quantity: quantity,
    variantPrice: variantPrice,
    variantcompareAtPrice: variantcompareAtPrice,
    localPrice: true,
    black: true
  }));
}; // propTypes


var Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Description__Wrapper",
  componentId: "sc-1kjb269-0"
})(["height:100%;flex:auto;display:block;"]);
/* harmony default export */ var CartItem_Description = (Description_Description);
// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/CartItem/Component.js
var Component_jsx = react_default.a.createElement;







var Component_CartItem = function CartItem(_ref) {
  var cartItemId = _ref.cartItemId,
      handle = _ref.handle,
      handleRemoveClick = _ref.handleRemoveClick,
      imageUrl = _ref.imageUrl,
      link = _ref.link,
      optionIds = _ref.optionIds,
      quantity = _ref.quantity,
      title = _ref.title,
      variantIds = _ref.variantIds;
  return /*#__PURE__*/react_default.a.createElement(StyledCartItem, null, /*#__PURE__*/react_default.a.createElement(ProductQuantity["a" /* NarrowQuantity */], {
    quantity: quantity,
    cartItemId: cartItemId,
    handle: handle
  }), /*#__PURE__*/react_default.a.createElement(CartItem_ProductImage, {
    title: title,
    imageUrl: imageUrl,
    link: link
  }), /*#__PURE__*/react_default.a.createElement(CartItem_Description, {
    cartItemId: cartItemId,
    handle: handle,
    link: link,
    optionIds: optionIds,
    quantity: quantity,
    title: title,
    variantIds: variantIds
  }), /*#__PURE__*/react_default.a.createElement(RemoveCartItem["a" /* default */], {
    handleRemoveClick: handleRemoveClick,
    cartItemId: cartItemId
  }));
};

var StyledCartItem = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Component__StyledCartItem",
  componentId: "vbmsq9-0"
})(["display:flex;align-items:center;height:auto;margin-bottom:", "px;text-align:left;@media ", "{margin-bottom:", "px;}@media ", "{margin-bottom:", "px;}"], function (props) {
  return props.theme.baseline * 5;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.baseline * 4;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.halfBaseline * 10;
}); // propTypes

/* harmony default export */ var CartItem_Component = (Component_CartItem);
// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/CartItem/Container.js






 // mapStateToProps

var CartItem_Container_mapStateToProps = function mapStateToProps(state, props) {
  var entities = state.entities;
  var cartItemId = props.cartItemId;
  var cartItem = entities.cartItems.byId[cartItemId];
  var variant = entities.variants.byId[cartItem.variantId];
  var product = entities.products.byId[variant.productId];
  var quantity = cartItem.quantity;
  var _state$settings = state.settings,
      regionId = _state$settings.regionId,
      currencyCode = _state$settings.currencyId;
  var shopId = regions_default.a.byId[regionId].shopId;
  var shopCurrencyCode = shops_default.a.byId[shopId].currencyId;
  var variantIds = product.variantIds,
      optionIds = product.optionIds,
      title = product.title,
      handle = product.handle;
  var productImages = Object(getProductImages["a" /* default */])(handle, variant.sku);
  var imageUrl = productImages.length ? productImages[0].url : ''; // TODO: Generate converted currency base on Country selected

  var variantPrice = Object(convertToCurrency["a" /* default */])(variant.price, shopCurrencyCode, currencyCode);
  return {
    variant: variant,
    cartItemId: cartItemId,
    optionIds: optionIds,
    variantIds: variantIds,
    quantity: quantity,
    title: title,
    handle: handle,
    variantPrice: variantPrice,
    currencyCode: currencyCode,
    imageUrl: imageUrl,
    link: {
      href: "/products/product?productHandle=".concat(product.handle),
      as: "/products/".concat(product.handle)
    }
  };
}; // MapDispatchToProps


var CartItem_Container_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleRemoveClick: function handleRemoveClick(event) {
      dispatch(Object(handleRemoveCartItem["a" /* default */])(event.currentTarget.getAttribute('data-id')));
    }
  };
};

var CartItemContainer = Object(es["b" /* connect */])(CartItem_Container_mapStateToProps, CartItem_Container_mapDispatchToProps)(CartItem_Component);
/* harmony default export */ var CartItem_Container = (CartItemContainer);
// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/CartItem/index.js

/* harmony default export */ var NarrowCart_CartItem = (CartItem_Container);
// EXTERNAL MODULE: ./actions/handleCheckoutProcess.jsx + 2 modules
var handleCheckoutProcess = __webpack_require__("6nWa");

// EXTERNAL MODULE: ./components/shared/Notifications/types.js
var types = __webpack_require__("qJix");

// EXTERNAL MODULE: ./actions/handleNotification.js + 2 modules
var handleNotification = __webpack_require__("SDM7");

// EXTERNAL MODULE: ./components/shared/Cart/shared/Consent/index.js + 1 modules
var Consent = __webpack_require__("PhIz");

// EXTERNAL MODULE: ./components/shared/Cart/shared/PaymentOptions/index.js
var PaymentOptions = __webpack_require__("uAAP");

// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/Checkout/PaymentOptions/index.js



var StyledPaymentOptions = Object(styled_components_browser_esm["default"])(PaymentOptions["a" /* default */]).withConfig({
  displayName: "PaymentOptions__StyledPaymentOptions",
  componentId: "grpdx-0"
})(["float:left;width:100%;background-color:", ";@media ", "{margin-top:", "px;}"], function (_ref) {
  var bgWhite = _ref.bgWhite;
  return bgWhite ? theme["a" /* default */].colors.white : theme["a" /* default */].colors.black2;
}, theme["a" /* default */].breakpoints.tablet, theme["a" /* default */].halfBaseline * 4);
/* harmony default export */ var Checkout_PaymentOptions = (StyledPaymentOptions);
// EXTERNAL MODULE: ./utils/generateClickableId.js
var generateClickableId = __webpack_require__("7dJx");

// EXTERNAL MODULE: ./components/shared/Cart/NarrowCart/Checkout/layout/index.js + 2 modules
var layout = __webpack_require__("ohNE");

// EXTERNAL MODULE: ./components/atoms/Button/index.js + 7 modules
var Button = __webpack_require__("8BE4");

// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/Checkout/Summary/CartButton/index.js
var CartButton_jsx = react_default.a.createElement;






var CartButton_CartButton = function CartButton(_ref) {
  var onCheckoutClick = _ref.onCheckoutClick,
      checkoutLoading = _ref.checkoutLoading,
      id = _ref.id;
  return /*#__PURE__*/react_default.a.createElement(CartButton_Button, {
    id: id,
    onClick: onCheckoutClick,
    isLoading: checkoutLoading,
    fixedWidth: true
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Check out"
  }));
};

var CartButton_Button = Object(styled_components_browser_esm["default"])(Button["c" /* PrimaryShopButton */]).withConfig({
  displayName: "CartButton__Button",
  componentId: "wda3sy-0"
})(["width:100%;margin-top:0;padding-left:", "px;@media ", "{min-width:auto;padding:0;}"], theme["a" /* default */].baseline, function (props) {
  return props.theme.breakpoints.tablet;
});
/* harmony default export */ var Summary_CartButton = (CartButton_CartButton);
// EXTERNAL MODULE: ./components/shared/ProductVAT/index.js
var ProductVAT = __webpack_require__("OCh6");

// EXTERNAL MODULE: ./components/shared/Cart/shared/TotalPrice/index.js + 2 modules
var TotalPrice = __webpack_require__("hxB5");

// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/Checkout/Summary/CartPrice/index.js

var CartPrice_jsx = react_default.a.createElement;












var CartPrice_CartPrice = function CartPrice(_ref) {
  var pricesIncludeVAT = _ref.pricesIncludeVAT,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["pricesIncludeVAT"]);

  var variants = Object(es["d" /* useSelector */])(function (state) {
    return state.entities.variants;
  });
  var regionId = Object(es["d" /* useSelector */])(function (state) {
    return state.settings.regionId;
  });
  var shopId = regions_default.a.byId[regionId].shopId; // Dynamically getting the variants through hook

  var dynamicVariants = Object(useGetDynamicVariants["a" /* default */])(variants.allIds, shopId);
  return /*#__PURE__*/react_default.a.createElement(CartPrice_Wrapper, {
    bgWhite: rest.bgWhite
  }, /*#__PURE__*/react_default.a.createElement(Info, null, /*#__PURE__*/react_default.a.createElement(CartPrice_Text, {
    bold: true,
    bgWhite: rest.bgWhite
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "products.checkout.total.title"
  })), /*#__PURE__*/react_default.a.createElement(StyledProductVAT, {
    pricesIncludeVAT: pricesIncludeVAT
  })), /*#__PURE__*/react_default.a.createElement(Price, {
    dynamicVariants: dynamicVariants
    /* showLocal */

  }));
};

var CartPrice_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CartPrice__Wrapper",
  componentId: "sc-13kurvm-0"
})(["display:flex;width:100%;flex-flow:column;background-color:", ";color:", ";@media ", "{height:100%;float:left;}"], function (props) {
  return props.bgWhite ? theme["a" /* default */].colors.white : theme["a" /* default */].colors.black;
}, function (props) {
  return props.bgWhite ? theme["a" /* default */].colors.black : theme["a" /* default */].colors.white;
}, theme["a" /* default */].breakpoints.tablet);
var Info = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CartPrice__Info",
  componentId: "sc-13kurvm-1"
})(["display:flex;flex-direction:column;align-items:flex-start;height:", "px;@media ", "{height:", "px;}"], theme["a" /* default */].halfBaseline * 6, theme["a" /* default */].breakpoints.tablet, theme["a" /* default */].halfBaseline * 7);
var StyledProductVAT = Object(styled_components_browser_esm["default"])(ProductVAT["a" /* default */]).withConfig({
  displayName: "CartPrice__StyledProductVAT",
  componentId: "sc-13kurvm-2"
})(["margin-top:", "px;@media ", "{margin-top:", "px;}"], theme["a" /* default */].halfBaseline, theme["a" /* default */].breakpoints.tablet, theme["a" /* default */].baseline);
var Price = Object(styled_components_browser_esm["default"])(TotalPrice["a" /* default */]).withConfig({
  displayName: "CartPrice__Price",
  componentId: "sc-13kurvm-3"
})(["text-align:left;margin-top:", "px;> div:nth-child(1){", ";font-family:", ";margin-bottom:", "px;}> div:nth-child(2){", ";}@media ", "{text-align:left;}"], theme["a" /* default */].baseline, bodyTextMixins["b" /* bodyTextMixin2 */], theme["a" /* default */].fonts.main, theme["a" /* default */].baseline, bodyTextMixins["c" /* bodyTextMixin3 */], theme["a" /* default */].breakpoints.tablet);
var CartPrice_Text = Object(styled_components_browser_esm["default"])(Text["f" /* H4 */]).withConfig({
  displayName: "CartPrice__Text",
  componentId: "sc-13kurvm-4"
})(["margin:0;color:", ";"], function (props) {
  return props.bgWhite ? theme["a" /* default */].colors.black : theme["a" /* default */].colors.white;
});
/* harmony default export */ var Summary_CartPrice = (CartPrice_CartPrice);
// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/Checkout/Summary/index.js
var Summary_jsx = react_default.a.createElement;







var Summary_Summary = function Summary(_ref) {
  var totalPrice = _ref.totalPrice,
      currencyCode = _ref.currencyCode,
      onCheckoutClick = _ref.onCheckoutClick,
      pricesIncludeVAT = _ref.pricesIncludeVAT,
      loadingCheckout = _ref.loadingCheckout,
      bgWhite = _ref.bgWhite,
      consentChecked = _ref.consentChecked,
      regionId = _ref.regionId;
  return /*#__PURE__*/react_default.a.createElement(Summary_Wrapper, {
    regionId: regionId
  }, /*#__PURE__*/react_default.a.createElement(Summary_CartPrice, {
    bgWhite: bgWhite,
    totalPrice: totalPrice,
    currencyCode: currencyCode,
    pricesIncludeVAT: pricesIncludeVAT
  }), /*#__PURE__*/react_default.a.createElement(Summary_CartButton, {
    id: Object(generateClickableId["a" /* generateClickableId */])(4, 'Global', 'Cart-Drawer', 'CheckOut'),
    onCheckoutClick: onCheckoutClick,
    checkoutLoading: loadingCheckout,
    consentChecked: consentChecked
  }));
};

var Summary_Wrapper = Object(styled_components_browser_esm["default"])(layout["a" /* Row */]).withConfig({
  displayName: "Summary__Wrapper",
  componentId: "sc-9w95c-0"
})(["padding-bottom:", "px;@media ", "{padding-bottom:0;}"], function (props) {
  return props.regionId === 'na' || props.regionId === 'ca' ? props.theme.halfBaseline * 5 : 0;
}, function (props) {
  return props.theme.breakpoints.tablet;
});
Summary_Summary.defaultProps = {
  bgWhite: false
};
/* harmony default export */ var Checkout_Summary = (Summary_Summary);
// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/Checkout/Component.js
var Checkout_Component_jsx = react_default.a.createElement;






var Component_Checkout = function Checkout(_ref) {
  var bgWhite = _ref.bgWhite,
      regionId = _ref.regionId,
      isConsentRequired = _ref.isConsentRequired,
      consentChecked = _ref.consentChecked,
      onConsentChange = _ref.onConsentChange,
      onCheckoutClick = _ref.onCheckoutClick,
      hideOnTablet = _ref.hideOnTablet,
      totalPrice = _ref.totalPrice,
      currencyCode = _ref.currencyCode,
      loadingCheckout = _ref.loadingCheckout,
      pricesIncludeVAT = _ref.pricesIncludeVAT;
  return /*#__PURE__*/react_default.a.createElement(layout["b" /* Wrapper */], {
    bgWhite: bgWhite,
    regionId: regionId
  }, /*#__PURE__*/react_default.a.createElement(Checkout_Summary, {
    onCheckoutClick: onCheckoutClick,
    bgWhite: bgWhite,
    consentChecked: consentChecked,
    regionId: regionId,
    totalPrice: totalPrice,
    currencyCode: currencyCode,
    pricesIncludeVAT: pricesIncludeVAT,
    loadingCheckout: loadingCheckout
  }), isConsentRequired && /*#__PURE__*/react_default.a.createElement(Consent["a" /* default */], {
    checkboxId: hideOnTablet ? 'cartPage-mobile__checkbox--consent' : 'cartDrawer__checkbox--consent',
    regionId: regionId,
    bgWhite: bgWhite,
    onChange: onConsentChange,
    consentChecked: consentChecked
  }), /*#__PURE__*/react_default.a.createElement(Checkout_PaymentOptions, {
    bgWhite: bgWhite
  }));
};

/* harmony default export */ var Checkout_Component = (Component_Checkout);
// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/Checkout/Container.js
var Checkout_Container_jsx = react_default.a.createElement;










var Container_ConnectedCheckout = function ConnectedCheckout(_ref) {
  var bgWhite = _ref.bgWhite,
      regionId = _ref.regionId,
      handleCheckoutClick = _ref.handleCheckoutClick,
      showNotification = _ref.showNotification,
      hideOnTablet = _ref.hideOnTablet,
      totalPrice = _ref.totalPrice,
      currencyCode = _ref.currencyCode,
      loadingCheckout = _ref.loadingCheckout,
      pricesIncludeVAT = _ref.pricesIncludeVAT;
  // List of countries that does not require user consent
  var nonComplianceRegions = ['na']; // Set consent required if current region is not in the list

  var isConsentRequired = !nonComplianceRegions.includes(regionId);

  var _useState = Object(react["useState"])(false),
      consentChecked = _useState[0],
      setConsentChecked = _useState[1]; // Set up notice when user click checkout without giving consent


  var onCheckoutClick = isConsentRequired && !consentChecked ? showNotification : handleCheckoutClick; // If region change, set consent value to default

  Object(react["useEffect"])(function () {
    setConsentChecked(false);
  }, [regionId]);
  return /*#__PURE__*/react_default.a.createElement(Checkout_Component, {
    bgWhite: bgWhite,
    regionId: regionId,
    isConsentRequired: isConsentRequired,
    consentChecked: consentChecked,
    onConsentChange: function onConsentChange() {
      return setConsentChecked(!consentChecked);
    },
    onCheckoutClick: onCheckoutClick,
    hideOnTablet: hideOnTablet,
    totalPrice: totalPrice,
    currencyCode: currencyCode,
    loadingCheckout: loadingCheckout,
    pricesIncludeVAT: pricesIncludeVAT
  });
};
/**
 * mapStateToProps
 *
 * @param {Object} state Redux state
 * @returns {Object} Props
 */


var Checkout_Container_mapStateToProps = function mapStateToProps(state) {
  var _state$entities = state.entities,
      cartItems = _state$entities.cartItems,
      variants = _state$entities.variants;
  var _state$settings = state.settings,
      regionId = _state$settings.regionId,
      currencyCode = _state$settings.currencyId;
  var shopId = regions_default.a.byId[regionId].shopId;
  var loadingCheckout = state.loading.checkout;
  var _shops$byId$shopId = shops_default.a.byId[shopId],
      pricesIncludeVAT = _shops$byId$shopId.pricesIncludeVAT,
      shopCurrencyCode = _shops$byId$shopId.currencyId;
  var cartItem;
  var price; // Calculate total price

  var totalPrice = cartItems.allIds.reduce(function (acc, cartItemId) {
    cartItem = cartItems.byId[cartItemId];
    price = parseFloat(variants.byId[cartItem.variantId].price);
    return acc + cartItem.quantity * Object(convertToCurrency["a" /* default */])(price, shopCurrencyCode, currencyCode);
  }, 0);
  return {
    regionId: regionId,
    totalPrice: totalPrice,
    pricesIncludeVAT: pricesIncludeVAT,
    currencyCode: currencyCode,
    loadingCheckout: loadingCheckout
  };
};
/**
 * mapDispatchToProps
 *
 * @param {Function} dispatch
 * @returns {Object}
 */


var Checkout_Container_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleCheckoutClick: function handleCheckoutClick() {
      dispatch(Object(handleCheckoutProcess["a" /* default */])());
    },
    showNotification: function showNotification() {
      var errMessage =
      /*i18n*/
      {
        id: "To proceed, agree with the terms and conditions."
      };
      dispatch(Object(handleNotification["a" /* default */])(types["b" /* ERROR */], errMessage, 3));
    }
  };
};

Container_ConnectedCheckout.defaultProps = {
  bgWhite: false
};
// Connect to redux state
var CheckoutContainer = Object(es["b" /* connect */])(Checkout_Container_mapStateToProps, Checkout_Container_mapDispatchToProps)(Container_ConnectedCheckout);
/* harmony default export */ var Checkout_Container = (CheckoutContainer);
// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/Checkout/index.js

/* harmony default export */ var NarrowCart_Checkout = (Checkout_Container);
// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/Component.js
var NarrowCart_Component_jsx = react_default.a.createElement;






var Component_CartItems = function CartItems(_ref) {
  var cartItemIds = _ref.cartItemIds,
      hideOnTablet = _ref.hideOnTablet,
      bgWhite = _ref.bgWhite,
      className = _ref.className;
  return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(StyledCartItems, {
    className: className,
    hideOnTablet: hideOnTablet
  }, cartItemIds.map(function (itemId) {
    return /*#__PURE__*/react_default.a.createElement(NarrowCart_CartItem, {
      key: itemId,
      cartItemId: itemId
    });
  }), /*#__PURE__*/react_default.a.createElement(shared_UpsellExtraBattery, null)), /*#__PURE__*/react_default.a.createElement(CartCheckout, {
    bgWhite: bgWhite,
    hideOnTablet: hideOnTablet
  }, /*#__PURE__*/react_default.a.createElement(NarrowCart_Checkout, {
    bgWhite: bgWhite,
    hideOnTablet: hideOnTablet
  })));
};

Component_CartItems.defaultProps = {
  hideOnTablet: false,
  bgWhite: false,
  className: null
}; // propTypes

var StyledCartItems = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Component__StyledCartItems",
  componentId: "yqr0wq-0"
})(["padding-left:", "px;padding-right:", "px;@media ", "{display:", ";padding-left:", "px;padding-right:", "px;}"], function (props) {
  return props.theme.baseline * 2;
}, function (props) {
  return props.theme.baseline * 2;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.hideOnTablet ? 'none' : 'block';
}, function (props) {
  return props.theme.baseline * 4;
}, function (props) {
  return props.theme.baseline * 4;
});
var CartCheckout = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Component__CartCheckout",
  componentId: "yqr0wq-1"
})(["width:100%;position:relative;bottom:0;background:", ";@media ", "{display:", ";}"], function (props) {
  return props.bgWhite ? props.theme.colors.white : props.theme.colors.black;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.hideOnTablet ? 'none' : 'block';
});
/* harmony default export */ var NarrowCart_Component = (Component_CartItems);
// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/Container.js

 // mapStateToProps

var NarrowCart_Container_mapStateToProps = function mapStateToProps(state) {
  return {
    cartItemIds: state.entities.cartItems.allIds
  };
};

var CartItemsContainer = Object(es["b" /* connect */])(NarrowCart_Container_mapStateToProps)(NarrowCart_Component);
/* harmony default export */ var NarrowCart_Container = (CartItemsContainer);
// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/index.js

/* harmony default export */ var NarrowCart = __webpack_exports__["a"] = (NarrowCart_Container);

/***/ }),

/***/ "3f9c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("HaE+");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");

// EXTERNAL MODULE: ./data/shops.js
var shops = __webpack_require__("z1id");
var shops_default = /*#__PURE__*/__webpack_require__.n(shops);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./actionTypes/index.js
var actionTypes = __webpack_require__("ifZB");

// CONCATENATED MODULE: ./actions/addDynamicVariants.ts


var addDynamicVariants_addDynamicVariants = function addDynamicVariants(dynamicVariants, dynamicVariantIds) {
  return {
    type: actionTypes["b" /* ADD_DYNAMIC_VARIANTS */],
    payload: {
      dynamicVariants: dynamicVariants,
      dynamicVariantIds: dynamicVariantIds
    }
  };
};

/* harmony default export */ var actions_addDynamicVariants = (addDynamicVariants_addDynamicVariants);
// CONCATENATED MODULE: ./utils/fetchShopifyDynamicVariants.ts



/**
 * The structure of the variants returned from the shopify api
 */
var fetchShopifyDynamicVariants = /*#__PURE__*/function () {
  var _ref = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(variantIds, shop) {
    var apiUrl, query, response, json, normalizedDynamicVariants;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            apiUrl = "https://".concat(shop.domain, "/api/2021-01/graphql.json");
            query = makeQuery(variantIds);
            _context.next = 4;
            return fetch(apiUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Shopify-Storefront-Access-Token': shop.storefrontAccessToken
              },
              body: JSON.stringify({
                query: query
              })
            });

          case 4:
            response = _context.sent;
            _context.next = 7;
            return response.json();

          case 7:
            json = _context.sent;
            normalizedDynamicVariants = json.data.nodes.map(function (apiVariant) {
              var _apiVariant$compareAt;

              var dynamicVariant = {
                id: apiVariant.id,
                price: apiVariant.priceV2.amount,
                available: apiVariant.availableForSale,
                compareAtPrice: (_apiVariant$compareAt = apiVariant.compareAtPriceV2) === null || _apiVariant$compareAt === void 0 ? void 0 : _apiVariant$compareAt.amount
              };
              return dynamicVariant;
            });
            return _context.abrupt("return", normalizedDynamicVariants);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchShopifyDynamicVariants(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var makeQuery = function makeQuery(variantIds) {
  return "\nquery {\n  nodes(ids: ".concat(JSON.stringify(variantIds), ") {\n    ... on ProductVariant {\n      id\n      availableForSale\n      compareAtPriceV2 {\n        amount\n      }\n      priceV2 {\n        amount\n        currencyCode\n      }\n    }\n  }\n}\n");
};

/* harmony default export */ var utils_fetchShopifyDynamicVariants = (fetchShopifyDynamicVariants);
// CONCATENATED MODULE: ./utils/hooks/useGetDynamicVariants.ts




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var useGetDynamicVariants_useGetDynamicVariants = function useGetDynamicVariants(variantIds, shopId) {
  var dispatch = Object(es["c" /* useDispatch */])();

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state.entities;
  }),
      dynamicVariants = _useSelector.dynamicVariants,
      products = _useSelector.products,
      variants = _useSelector.variants; // Only search for missing variant int the currently selected shop


  var currentShopVariantIds = variantIds.filter(function (variantId) {
    var _products$byId$varian, _variants$byId$varian;

    return ((_products$byId$varian = products.byId[(_variants$byId$varian = variants.byId[variantId]) === null || _variants$byId$varian === void 0 ? void 0 : _variants$byId$varian.productId]) === null || _products$byId$varian === void 0 ? void 0 : _products$byId$varian.shopId) === shopId;
  });
  Object(react["useEffect"])(function () {
    function fetchVariants() {
      return _fetchVariants.apply(this, arguments);
    }

    function _fetchVariants() {
      _fetchVariants = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var missingIds, fetchedDynamicVariants, dynamicVariantsById, dynamicVariantIds;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Filter out the variantIds that are not already in the cache and only fetch those
                missingIds = currentShopVariantIds.filter(function (variantId) {
                  var _dynamicVariants$byId;

                  return !((_dynamicVariants$byId = dynamicVariants.byId) === null || _dynamicVariants$byId === void 0 ? void 0 : _dynamicVariants$byId[variantId]);
                }); // If all the variantIds are already in the cache, return;

                if (missingIds.length) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _context.next = 5;
                return utils_fetchShopifyDynamicVariants(missingIds, shops_default.a.byId[shopId]);

              case 5:
                fetchedDynamicVariants = _context.sent;
                dynamicVariantsById = fetchedDynamicVariants.reduce(function (acc, variant) {
                  return _objectSpread(_objectSpread({}, acc), {}, Object(defineProperty["a" /* default */])({}, variant.id, variant));
                }, {});
                dynamicVariantIds = Object.keys(dynamicVariantsById);
                dispatch(actions_addDynamicVariants(dynamicVariantsById, dynamicVariantIds));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchVariants.apply(this, arguments);
    }

    fetchVariants(); // Making variantIds to a string to prevent unessesary rerender (and refetch), thus disabling exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, shopId, dynamicVariants.byId, JSON.stringify(currentShopVariantIds)]);
  return dynamicVariants;
};

/* harmony default export */ var hooks_useGetDynamicVariants = __webpack_exports__["a"] = (useGetDynamicVariants_useGetDynamicVariants);

/***/ }),

/***/ "43V8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ifZB");

/**
 * changeCartItemQuantity
 *
 * @param {String} cartItemId Id of targeted cart item
 * @param {Number} number Quantity that is added
 * @returns {Object} Redux action
 */

var changeCartItemQuantity = function changeCartItemQuantity(cartItemId, number) {
  return {
    type: actionTypes__WEBPACK_IMPORTED_MODULE_0__[/* CHANGE_CART_ITEM_QUANTITY */ "f"],
    payload: {
      cartItemId: cartItemId,
      number: number
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (changeCartItemQuantity);

/***/ }),

/***/ "5Aug":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ Price_RegionPrice; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ Price_LocalPrice; });

// EXTERNAL MODULE: ./node_modules/@lingui/react/index.js
var react = __webpack_require__("ZD0w");

// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__("q1tI");
var node_modules_react_default = /*#__PURE__*/__webpack_require__.n(node_modules_react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./data/regions.js
var regions = __webpack_require__("keR7");
var regions_default = /*#__PURE__*/__webpack_require__.n(regions);

// EXTERNAL MODULE: ./data/shops.js
var shops = __webpack_require__("z1id");
var shops_default = /*#__PURE__*/__webpack_require__.n(shops);

// CONCATENATED MODULE: ./components/shared/Price/RegionPrice.js
var __jsx = node_modules_react_default.a.createElement;






var RegionPrice_RegionPrice = function RegionPrice(_ref) {
  var price = _ref.price,
      currencyId = _ref.currencyId;
  return /*#__PURE__*/node_modules_react_default.a.createElement(react["NumberFormat"], {
    value: parseFloat(price),
    format: {
      style: 'currency',
      currency: currencyId,
      minimumFractionDigits: 0
    }
  });
};

// Map state to props
var RegionPrice_mapStateToProps = function mapStateToProps(state) {
  var regionId = state.settings.regionId;
  var shopId = regions_default.a.byId[regionId].shopId;
  var currencyId = shops_default.a.byId[shopId].currencyId;
  return {
    currencyId: currencyId
  };
};

/* harmony default export */ var Price_RegionPrice = (Object(es["b" /* connect */])(RegionPrice_mapStateToProps)(RegionPrice_RegionPrice));
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./styles/theme.js
var theme = __webpack_require__("NVT0");

// EXTERNAL MODULE: ./utils/convertToCurrency.js
var convertToCurrency = __webpack_require__("+YIU");

// EXTERNAL MODULE: ./data/countries.js
var countries = __webpack_require__("gT3G");

// EXTERNAL MODULE: ./components/atoms/Text/mixins/bodyTextMixins.js
var bodyTextMixins = __webpack_require__("hcoH");

// CONCATENATED MODULE: ./components/shared/Price/LocalPrice.js
var LocalPrice_jsx = node_modules_react_default.a.createElement;











var LocalPrice_LocalPrice = function LocalPrice(_ref) {
  var className = _ref.className,
      price = _ref.price,
      localCurrencyCode = _ref.localCurrencyCode,
      shopCurrencyCode = _ref.shopCurrencyCode;
  var priceFloat = parseFloat(price);
  var localPrice = Object(convertToCurrency["a" /* default */])(priceFloat, shopCurrencyCode, localCurrencyCode);
  return (// Do not show local price if country does not have conversion
    localCurrencyCode && localCurrencyCode !== shopCurrencyCode && /*#__PURE__*/node_modules_react_default.a.createElement(node_modules_react_default.a.Fragment, null, /*#__PURE__*/node_modules_react_default.a.createElement(StyledLocalPrice, {
      className: className
    }, "\u2248", ' ', /*#__PURE__*/node_modules_react_default.a.createElement(react["NumberFormat"], {
      value: Math.round(localPrice),
      format: {
        style: 'currency',
        currency: localCurrencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }
    })))
  );
};

var StyledLocalPrice = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LocalPrice__StyledLocalPrice",
  componentId: "dw7q0h-0"
})(["", " color:", ";"], bodyTextMixins["c" /* bodyTextMixin3 */], theme["a" /* default */].colors.grey);
LocalPrice_LocalPrice.defaultProps = {
  className: ''
};

// Map state to props
var LocalPrice_mapStateToProps = function mapStateToProps(state) {
  var _state$settings = state.settings,
      countryId = _state$settings.countryId,
      regionId = _state$settings.regionId;
  var shopId = regions_default.a.byId[regionId].shopId;
  var shopCurrencyCode = shops_default.a.byId[shopId].currencyId;
  var localCurrencyCode = null;

  try {
    localCurrencyCode = countries["a" /* default */].byId[countryId].currencyId;
  } catch (e) {
    console.log("Country you selected does not support currency conversion ".concat(e));
  }

  return {
    localCurrencyCode: localCurrencyCode,
    shopCurrencyCode: shopCurrencyCode
  };
};

/* harmony default export */ var Price_LocalPrice = (Object(es["b" /* connect */])(LocalPrice_mapStateToProps)(LocalPrice_LocalPrice));
// CONCATENATED MODULE: ./components/shared/Price/index.js




/***/ }),

/***/ "66rl":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogbm9uZTsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBmaWxsOiAjMjEyMzIyOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8ZyBpZD0iaWNvbi1kZWxldGUtYmxhY2stMjRweCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI4MyAtNjcuNjg2KSI+CiAgICA8ZyBpZD0iR3JvdXBfMTk5NSIgZGF0YS1uYW1lPSJHcm91cCAxOTk1Ij4KICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8xNjMxIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxNjMxIiBjbGFzcz0iY2xzLTEiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjgzIDY3LjY4NSkiLz4KICAgICAgPGcgaWQ9Ikdyb3VwXzIwNzMiIGRhdGEtbmFtZT0iR3JvdXAgMjA3MyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjgzIDY3LjY4NikiPgogICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTk0OCIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMTk0OCIgY2xhc3M9ImNscy0yIiB3aWR0aD0iMi4yMjIiIGhlaWdodD0iOC44ODkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDYuNjY3IDYuNjY3KSIvPgogICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTk0OSIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMTk0OSIgY2xhc3M9ImNscy0yIiB3aWR0aD0iMi4yMjIiIGhlaWdodD0iOC44ODkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExLjExMSA2LjY2NykiLz4KICAgICAgICA8cGF0aCBpZD0iUGF0aF8xNTI5IiBkYXRhLW5hbWU9IlBhdGggMTUyOSIgY2xhc3M9ImNscy0yIiBkPSJNMjAsMi4yMjJIMTMuMzMzVjBINi42NjdWMi4yMjJIMFY0LjQ0NEgxLjIyMkwyLjIyMiwyMEgxNy43NzhsMS0xNS41NTZIMjBaTTE1LjY2NywxNy43NzhINC4zMzNMMy40NDQsNC40NDRIMTYuNTU2WiIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K" };

/***/ }),

/***/ "6nWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ handleCheckoutProcess; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("HaE+");

// EXTERNAL MODULE: ./node_modules/next/dist/build/polyfills/fetch/index.js
var fetch = __webpack_require__("vcXL");
var fetch_default = /*#__PURE__*/__webpack_require__.n(fetch);

// EXTERNAL MODULE: ./node_modules/shopify-buy/index.js
var shopify_buy = __webpack_require__("FoNT");
var shopify_buy_default = /*#__PURE__*/__webpack_require__.n(shopify_buy);

// EXTERNAL MODULE: ./data/shops.js
var shops = __webpack_require__("z1id");
var shops_default = /*#__PURE__*/__webpack_require__.n(shops);

// EXTERNAL MODULE: ./data/regions.js
var regions = __webpack_require__("keR7");
var regions_default = /*#__PURE__*/__webpack_require__.n(regions);

// EXTERNAL MODULE: ./actionTypes/index.js
var actionTypes = __webpack_require__("ifZB");

// CONCATENATED MODULE: ./actions/setLoadingCheckout.js

/**
 * setLoadingCheckout
 *
 * @param {Boolean} loading Is loading?
 * @returns {Object} Action for reducer
 */

var setLoadingCheckout_setLoadingCheckout = function setLoadingCheckout(loading) {
  return {
    type: actionTypes["x" /* SET_LOADING_CHECKOUT */],
    payload: loading
  };
};

/* harmony default export */ var actions_setLoadingCheckout = (setLoadingCheckout_setLoadingCheckout);
// CONCATENATED MODULE: ./actions/setCheckout.js

/**
 * setCheckout
 *
 * @param {String} checkoutId Id of checkout
 * @param {String} webUrl Url that leads to shopify checkout
 * @returns {Object} Action for reducer
 */

var setCheckout_setCheckout = function setCheckout(checkoutId, webUrl) {
  return {
    type: actionTypes["q" /* SET_CHECKOUT */],
    payload: {
      checkoutId: checkoutId,
      webUrl: webUrl
    }
  };
};

/* harmony default export */ var actions_setCheckout = (setCheckout_setCheckout);
// EXTERNAL MODULE: ./actions/handleNotification.js + 2 modules
var handleNotification = __webpack_require__("SDM7");

// EXTERNAL MODULE: ./components/shared/Notifications/types.js
var types = __webpack_require__("qJix");

// EXTERNAL MODULE: ./utils/logging/sentry.ts + 56 modules
var sentry = __webpack_require__("/I/W");

// EXTERNAL MODULE: ./components/wrappers/PageTracker/utils.ts + 1 modules
var utils = __webpack_require__("IUCn");

// CONCATENATED MODULE: ./actions/handleCheckoutProcess.jsx



/* eslint-disable no-underscore-dangle */
// prettier-ignore-file









 // Black Friday

var bfGiftCardSKUs = {
  eu: 'gift_card_eu_150',
  fr: 'gift_card_eu_150',
  dk: 'gift_card_dk_1100',
  no: 'gift_card_no_1700',
  de: 'gift_card_de_150'
}; // Black Friday

var bfSKUsWithGiftCard = ['11-BF20_B_S_GiftCard', '11-BF20_B_GB_GiftCard', '11-BF20_W_S_GiftCard', '11-BF20_W_GB_GiftCard', '11-BF20_O_S_GiftCard', '11-BF20_O_GB_GiftCard'];
/**
 * handleCheckoutProcess
 *
 * @returns {Function} Thunk for Redux
 */

function handleCheckoutProcess() {
  return /*#__PURE__*/function () {
    var _thunk = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(dispatch, getState) {
      var state, region, currencyId, shop, client, _state$entities, cartItems, products, variants, bfGiftCardSKU, bfGiftCardVariantId, lineItemsToAdd, checkout, klaviyoQueryParam, cjEventParam, localeQueryParam, checkoutUrl;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();

              if (!(state.loading.checkout === true)) {
                _context.next = 4;
                break;
              }

              dispatch(Object(handleNotification["a" /* default */])(types["c" /* INFO */],
              /*i18n*/
              {
                id: "Checkout is already loading."
              }, 5));
              return _context.abrupt("return");

            case 4:
              dispatch(actions_setLoadingCheckout(true));
              region = regions_default.a.byId[state.settings.regionId];
              currencyId = region.currencyId;
              shop = shops_default.a.byId[region.shopId]; // Create shopify client
              // prettier-ignore

              client = shopify_buy_default.a.buildClient({
                domain: shop.domain,
                storefrontAccessToken: shop.storefrontAccessToken
              }, fetch_default.a);
              _state$entities = state.entities, cartItems = _state$entities.cartItems, products = _state$entities.products, variants = _state$entities.variants;
              bfGiftCardSKU = bfGiftCardSKUs[region.id];
              bfGiftCardVariantId = variants.allIds.find(function (id) {
                var variant = variants.byId[id];
                return variant.sku === bfGiftCardSKU;
              }); // Reduce cart items to fitting format
              // Process to an array of variantIds to send together with the request

              lineItemsToAdd = cartItems.allIds.reduce(function (acc, cartItemId) {
                var cartItem = cartItems.byId[cartItemId];
                acc.push({
                  variantId: cartItem.variantId,
                  quantity: cartItem.quantity
                }); // Black Friday

                var cartItemSKU = variants.byId[cartItem.variantId].sku;

                if (bfSKUsWithGiftCard.includes(cartItemSKU) && bfGiftCardVariantId) {
                  acc.push({
                    variantId: bfGiftCardVariantId,
                    quantity: cartItem.quantity
                  });
                }

                return acc;
              }, []); // Create checkout

              _context.prev = 13;
              _context.next = 16;
              return client.checkout.create();

            case 16:
              checkout = _context.sent;
              // Set Checkout info in state
              dispatch(actions_setCheckout(checkout.id, checkout.webUrl)); // Add items to checkout

              _context.next = 20;
              return client.checkout.addLineItems(checkout.id, lineItemsToAdd);

            case 20:
              // get Klaviyo email for cross tracking
              klaviyoQueryParam = Object(utils["g" /* trackKlaviyoCrossTrackingEmail */])();
              cjEventParam = Object(utils["b" /* trackCJEventIdFromCookie */])();
              localeQueryParam = "&locale=".concat(state.settings.languageId); // Build checkout URL with Klaviyo and locale

              checkoutUrl = "".concat(checkout.webUrl).concat(klaviyoQueryParam).concat(cjEventParam).concat(localeQueryParam);
              Object(utils["l" /* trackStartCheckout */])({
                cartItems: cartItems,
                products: products,
                variants: variants,
                checkoutUrl: checkoutUrl,
                checkoutId: checkout.id,
                currencyId: currencyId
              }); // Redirect to checkout page

              window.location.href = checkoutUrl;
              _context.next = 34;
              break;

            case 28:
              _context.prev = 28;
              _context.t0 = _context["catch"](13);
              console.error("Error: Failed while creating checkout: ".concat(_context.t0));
              sentry["a" /* Logger */].error(_context.t0, {
                contexts: {
                  FunctionName: 'handleCheckoutProcess',
                  ExtraData: JSON.stringify(lineItemsToAdd)
                }
              });
              dispatch(Object(handleNotification["a" /* default */])(types["b" /* ERROR */],
              /*i18n*/
              {
                id: "errorMessage.checkout.general"
              }, 5));
              dispatch(actions_setLoadingCheckout(false));

            case 34:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[13, 28]]);
    }));

    function thunk(_x, _x2) {
      return _thunk.apply(this, arguments);
    }

    return thunk;
  }();
}

/***/ }),

/***/ "AfKe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("Ff2n");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("vOnD");
/* harmony import */ var public_static_icons_trash_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("66rl");
/* harmony import */ var public_static_icons_trash_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(public_static_icons_trash_svg__WEBPACK_IMPORTED_MODULE_3__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;


 // Quantity

var RemoveCartItem = function RemoveCartItem(_ref) {
  var handleRemoveClick = _ref.handleRemoveClick,
      cartItemId = _ref.cartItemId,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, ["handleRemoveClick", "cartItemId"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(Wrapper, {
    className: rest.className
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("button", {
    "data-id": cartItemId,
    type: "button",
    onClick: handleRemoveClick
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("img", {
    alt: "cart",
    src: public_static_icons_trash_svg__WEBPACK_IMPORTED_MODULE_3___default.a.url
  })));
}; // Wrapper


var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
  displayName: "RemoveCartItem__Wrapper",
  componentId: "sc-13xqe1y-0"
})(["float:right;margin-left:", "px;height:100%;display:flex;justify-content:flex-end;align-items:center;button{cursor:pointer;padding:0;}img{height:", "px;}@media ", "{img{height:", "px;}}"], function (props) {
  return props.theme.halfBaseline * 4;
}, function (props) {
  return props.theme.baseline * 2;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.halfBaseline * 5;
}); // PropTypes

/* harmony default export */ __webpack_exports__["a"] = (RemoveCartItem);

/***/ }),

/***/ "CJuD":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/png;base64,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" };

/***/ }),

/***/ "Dwz9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * getVariantFromOption
 *
 * Find a variant that matches selected options. The selectedOptions are in the
 * format:
 * selectedOptions = {
 *  [optionId]: optionValue,
 *  ...
 * }
 * If no variant is found, null is returned.
 *
 * @param {Object} variants an array of variants
 * @param {Object} selectedOptions an object of available options for a product
 * @returns {Object|null} A variant which its option matches selected options
 */
var getVariantFromOptions = function getVariantFromOptions(variants, selectedOptions) {
  if (variants && selectedOptions) {
    return variants // Find a single element that matches options
    .find(function (variant) {
      return Object.keys(selectedOptions).reduce(function (acc, key) {
        acc.push(selectedOptions[key].value === variant.options[key].value);
        return acc;
      }, []).every(function (item) {
        return item;
      });
    }) || null; // Check if all compares are true
  }

  return null;
};

/* harmony default export */ __webpack_exports__["a"] = (getVariantFromOptions);

/***/ }),

/***/ "H9RR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ Container_NarrowQuantity; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ Container_WideQuantity; });

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./actions/changeCartItemQuantity.js
var changeCartItemQuantity = __webpack_require__("43V8");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./components/atoms/Text/index.js + 17 modules
var Text = __webpack_require__("wCgk");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./components/shared/Cart/shared/ProductQuantity/images/icons/caret-up.svg
var caret_up = __webpack_require__("0x+k");
var caret_up_default = /*#__PURE__*/__webpack_require__.n(caret_up);

// CONCATENATED MODULE: ./components/shared/Cart/shared/ProductQuantity/NarrowQuantity/Component.js
var __jsx = react_default.a.createElement;





var Component_Component = function Component(_ref) {
  var quantity = _ref.quantity,
      cartItemId = _ref.cartItemId,
      handleIncreaseQuantityClick = _ref.handleIncreaseQuantityClick,
      handleDecreaseQuantityClick = _ref.handleDecreaseQuantityClick;
  return /*#__PURE__*/react_default.a.createElement(Quantity, null, /*#__PURE__*/react_default.a.createElement(Add, {
    alt: "Add",
    src: caret_up_default.a.url,
    "data-id": cartItemId,
    onClick: handleIncreaseQuantityClick
  }), /*#__PURE__*/react_default.a.createElement(Component_Number, null, quantity), /*#__PURE__*/react_default.a.createElement(Minus, {
    alt: "Sub",
    src: caret_up_default.a.url,
    "data-id": cartItemId,
    onClick: handleDecreaseQuantityClick
  }));
};

var Quantity = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Component__Quantity",
  componentId: "sc-1hisp7d-0"
})(["display:flex;flex-flow:column;justify-content:space-between;align-self:center;justify-content:space-between;align-items:center;margin-right:", "px;@media ", "{margin-right:", "px;}"], function (props) {
  return props.theme.halfBaseline * 3;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.halfBaseline * 5;
});
var Component_Number = Object(styled_components_browser_esm["default"])(Text["f" /* H4 */]).withConfig({
  displayName: "Component__Number",
  componentId: "sc-1hisp7d-1"
})(["margin:", "px 0;"], function (props) {
  return props.theme.halfBaseline;
});
var Add = styled_components_browser_esm["default"].img.withConfig({
  displayName: "Component__Add",
  componentId: "sc-1hisp7d-2"
})(["padding:0;cursor:pointer;width:", "px;height:", "px;@media ", "{width:", "px;height:", "px;}"], function (props) {
  return props.theme.halfBaseline * 3;
}, function (props) {
  return props.theme.halfBaseline * 3;
}, function (props) {
  return props.theme.breakpoints.onlyMobile;
}, function (props) {
  return props.theme.halfBaseline * 4;
}, function (props) {
  return props.theme.halfBaseline * 4;
});
var Minus = Object(styled_components_browser_esm["default"])(Add).withConfig({
  displayName: "Component__Minus",
  componentId: "sc-1hisp7d-3"
})(["transform:rotate(180deg);"]);
/* harmony default export */ var NarrowQuantity_Component = (Component_Component);
// CONCATENATED MODULE: ./components/shared/Cart/shared/ProductQuantity/NarrowQuantity/index.js

/* harmony default export */ var NarrowQuantity = (NarrowQuantity_Component);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("Ff2n");

// EXTERNAL MODULE: ./components/atoms/Text/mixins/bodyTextMixins.js
var bodyTextMixins = __webpack_require__("hcoH");

// EXTERNAL MODULE: ./components/shared/Cart/shared/ProductQuantity/images/icons/minus.svg
var minus = __webpack_require__("yFDH");
var minus_default = /*#__PURE__*/__webpack_require__.n(minus);

// EXTERNAL MODULE: ./components/shared/Cart/shared/ProductQuantity/images/icons/plus.svg
var plus = __webpack_require__("x4ww");
var plus_default = /*#__PURE__*/__webpack_require__.n(plus);

// CONCATENATED MODULE: ./components/shared/Cart/shared/ProductQuantity/WideQuantity/index.js

var WideQuantity_jsx = react_default.a.createElement;






var WideQuantity_Component = function Component(_ref) {
  var quantity = _ref.quantity,
      cartItemId = _ref.cartItemId,
      handleIncreaseQuantityClick = _ref.handleIncreaseQuantityClick,
      handleDecreaseQuantityClick = _ref.handleDecreaseQuantityClick,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["quantity", "cartItemId", "handleIncreaseQuantityClick", "handleDecreaseQuantityClick"]);

  return /*#__PURE__*/react_default.a.createElement(Wrapper, {
    className: rest.className
  }, /*#__PURE__*/react_default.a.createElement(WideQuantity_Quantity, null, /*#__PURE__*/react_default.a.createElement(Button, {
    alt: "Add",
    src: plus_default.a.url,
    "data-id": cartItemId,
    onClick: handleIncreaseQuantityClick
  }), /*#__PURE__*/react_default.a.createElement(WideQuantity_Number, null, quantity), /*#__PURE__*/react_default.a.createElement(Button, {
    alt: "Sub",
    src: minus_default.a.url,
    "data-id": cartItemId,
    onClick: handleDecreaseQuantityClick
  })));
}; // PropTypes


var Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "WideQuantity__Wrapper",
  componentId: "sc-1ysklf2-0"
})([""]);
var WideQuantity_Quantity = styled_components_browser_esm["default"].div.withConfig({
  displayName: "WideQuantity__Quantity",
  componentId: "sc-1ysklf2-1"
})(["display:flex;flex-flow:row;justify-content:space-between;align-items:center;margin-right:", "px;height:100%;width:", "px;"], function (props) {
  return props.theme.halfBaseline * 3;
}, function (props) {
  return props.theme.halfBaseline * 15;
});
var WideQuantity_Number = styled_components_browser_esm["default"].div.withConfig({
  displayName: "WideQuantity__Number",
  componentId: "sc-1ysklf2-2"
})(["", ";margin:0 ", "px;@media ", "{margin:0 ", "px;}"], bodyTextMixins["b" /* bodyTextMixin2 */], function (props) {
  return props.theme.halfBaseline * 3;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.halfBaseline * 4;
});
var Button = styled_components_browser_esm["default"].img.withConfig({
  displayName: "WideQuantity__Button",
  componentId: "sc-1ysklf2-3"
})(["padding:0;cursor:pointer;width:", "px;height:", "px;@media ", "{width:", "px;height:", "px;}"], function (props) {
  return props.theme.halfBaseline * 3;
}, function (props) {
  return props.theme.halfBaseline * 3;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.halfBaseline * 5;
}, function (props) {
  return props.theme.halfBaseline * 5;
});
/* harmony default export */ var WideQuantity = (WideQuantity_Component);
// CONCATENATED MODULE: ./components/shared/Cart/shared/ProductQuantity/Container.js



 // MapDispatchToProps

var Container_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleDecreaseQuantityClick: function handleDecreaseQuantityClick(e) {
      dispatch(Object(changeCartItemQuantity["a" /* default */])(e.currentTarget.getAttribute('data-id'), -1));
    },
    handleIncreaseQuantityClick: function handleIncreaseQuantityClick(e) {
      dispatch(Object(changeCartItemQuantity["a" /* default */])(e.currentTarget.getAttribute('data-id'), 1));
    }
  };
}; // Connect to Redux


var Container_NarrowQuantity = Object(es["b" /* connect */])(null, Container_mapDispatchToProps)(NarrowQuantity);
var Container_WideQuantity = Object(es["b" /* connect */])(null, Container_mapDispatchToProps)(WideQuantity);

// CONCATENATED MODULE: ./components/shared/Cart/shared/ProductQuantity/index.js



/***/ }),

/***/ "HOtW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./data/abstractProducts.js
var abstractProducts = __webpack_require__("eTmy");
var abstractProducts_default = /*#__PURE__*/__webpack_require__.n(abstractProducts);

// EXTERNAL MODULE: ./actionTypes/index.js
var actionTypes = __webpack_require__("ifZB");

// CONCATENATED MODULE: ./actions/changeCartItemVariant.js

/**
 * changeCartItemVariant
 *
 * @param {String} cartItemId Id of targeted cart item
 * @param {String} variantId Id of new selected variant
 * @returns {Object} Redux action
 */

var changeCartItemVariant_changeCartItemVariant = function changeCartItemVariant(cartItemId, variantId) {
  return {
    type: actionTypes["g" /* CHANGE_CART_ITEM_VARIANT */],
    payload: {
      cartItemId: cartItemId,
      variantId: variantId
    }
  };
};

/* harmony default export */ var actions_changeCartItemVariant = (changeCartItemVariant_changeCartItemVariant);
// EXTERNAL MODULE: ./utils/product/getVariantFromOptions.js
var getVariantFromOptions = __webpack_require__("Dwz9");

// CONCATENATED MODULE: ./utils/product/getOptionsFromVariant.js
/**
 * getVariantFromOption
 *
 * Find a variant that matches selected options
 *
 * @param {Object} variants an array of variants
 * @param {string} variantId selected variant id from Redux cartItems
 * @returns {Object} An object of selected variants
 */
var getOptionsFromVariant = function getOptionsFromVariant(variants, variantId) {
  var variant = variants.find(function (o) {
    return o.id === variantId;
  });
  var variantOptions = variant;

  try {
    variantOptions = variant.options;
  } catch (e) {
    console.log("".concat(e, " No Options available for this variant"));
  }

  return variantOptions;
};

/* harmony default export */ var product_getOptionsFromVariant = (getOptionsFromVariant);
// EXTERNAL MODULE: ./components/atoms/FormElements/index.js + 13 modules
var FormElements = __webpack_require__("DAQc");

// CONCATENATED MODULE: ./components/shared/Cart/shared/ProductOptions/Component.js
var __jsx = react_default.a.createElement;



var Component_Options = function Options(_ref) {
  var options = _ref.options,
      className = _ref.className,
      cartItemId = _ref.cartItemId,
      selectedOptions = _ref.selectedOptions,
      onOptionChange = _ref.onOptionChange;
  return /*#__PURE__*/react_default.a.createElement("div", {
    onChange: onOptionChange
  }, options.map(function (option) {
    return typeof option !== 'undefined' && /*#__PURE__*/react_default.a.createElement(FormElements["e" /* Select */], {
      selectId: option.id,
      key: option.id,
      alt: cartItemId,
      className: className,
      onChange: function onChange(e) {
        return e.preventDefault();
      },
      name: option.name,
      defaultValue: selectedOptions[option.id].value
    }, option.values.map(function (value) {
      return /*#__PURE__*/react_default.a.createElement("option", {
        key: value,
        value: value
      }, value);
    }));
  }));
}; // PropTypes


Component_Options.defaultProps = {
  className: null
};
/* harmony default export */ var Component = (Component_Options);
// CONCATENATED MODULE: ./components/shared/Cart/shared/ProductOptions/Container.js

var Container_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







 // Use this function to delegate event that bubbled up to Select box parent.

var _onOptionChange = function onOptionChange(event, handleOptionChange, variants, cartItemId) {
  event.preventDefault(); // Convert all `select` nodes inside parent to array

  var optionNodes = Array.prototype.slice.call(event.currentTarget.querySelectorAll('select')); // Normalize the node array to a flat object

  var selectedOptions = optionNodes.reduce(function (acc, node) {
    return _objectSpread(_objectSpread({}, acc), {}, Object(defineProperty["a" /* default */])({}, node.id, {
      name: node.name,
      value: node.value
    }));
  }, {});
  var selectedVariant = Object(getVariantFromOptions["a" /* default */])(variants, selectedOptions);
  var variantId = selectedVariant.id; // Check variant Ids here

  handleOptionChange(cartItemId, variantId);
}; // Assemble component


var Container_ConnectedOptions = function ConnectedOptions(_ref) {
  var options = _ref.options,
      className = _ref.className,
      cartItemId = _ref.cartItemId,
      variants = _ref.variants,
      selectedVariantId = _ref.selectedVariantId,
      handleOptionChange = _ref.handleOptionChange,
      excludeProductOptionsCart = _ref.excludeProductOptionsCart;
  // Get selected options
  var selectedOptions = product_getOptionsFromVariant(variants, selectedVariantId); // Check if availble option of product is default one

  var hasDefaultOption = options.find(function (option) {
    return option.values[0] === 'Default Title';
  }); // Only show options select if has no more than 1 option and is is not default one.

  var showOptions = options.length > 1 || hasDefaultOption === undefined && options.length === 1;
  return showOptions && /*#__PURE__*/react_default.a.createElement(Component, {
    options: options,
    className: className,
    cartItemId: cartItemId,
    variantId: selectedVariantId,
    selectedOptions: selectedOptions,
    excludeProductOptionsCart: excludeProductOptionsCart,
    onOptionChange: function onOptionChange(e) {
      return _onOptionChange(e, handleOptionChange, variants, cartItemId);
    }
  });
}; // PropTypes


// Default props
Container_ConnectedOptions.defaultProps = {
  className: null,
  excludeProductOptionsCart: []
}; // mapStateToProps

var Container_mapStateToProps = function mapStateToProps(state, props) {
  var variantIds = props.variantIds,
      optionIds = props.optionIds,
      cartItemId = props.cartItemId;
  var countryId = state.settings.countryId;
  var allVariants = state.entities.variants.byId;
  var allOptions = state.entities.options.byId;
  var isDefaultVariant = state.entities.cartItems.byId[cartItemId].isDefaultVariant;
  var selectedVariantId = state.entities.cartItems.byId[cartItemId].variantId;
  var variant = state.entities.variants.byId[selectedVariantId];
  var selectedHandle = state.entities.products.byId[variant.productId].handle;
  var excludeProductOptionsCart = abstractProducts_default.a.byId[selectedHandle].excludeProductOptionsCart; // Build a `variant` object

  var variants = variantIds.map(function (variantId) {
    return allVariants[variantId];
  }); // Build an `options` object

  var options = optionIds.map(function (optionId) {
    return allOptions[optionId];
  }); // Order options by...

  var sortBy = ['Grill Color', 'Batteries', 'Plug Type'];
  options.sort(function (a, b) {
    if (sortBy.indexOf(a.name) < sortBy.indexOf(b.name)) {
      return -1;
    }

    if (sortBy.indexOf(a.name) > sortBy.indexOf(b.name)) {
      return 1;
    }

    return 0;
  });
  return {
    options: options,
    variants: variants,
    selectedVariantId: selectedVariantId,
    countryId: countryId,
    isDefaultVariant: isDefaultVariant,
    excludeProductOptionsCart: excludeProductOptionsCart
  };
}; // mapDispatchToProps


var Container_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleOptionChange: function handleOptionChange(cartItemId, variantId) {
      dispatch(actions_changeCartItemVariant(cartItemId, variantId));
    }
  };
}; // Connect to Redux


var OptionsContainer = Object(es["b" /* connect */])(Container_mapStateToProps, Container_mapDispatchToProps)(Container_ConnectedOptions);
/* harmony default export */ var Container = (OptionsContainer);
// CONCATENATED MODULE: ./components/shared/Cart/shared/ProductOptions/index.js

/* harmony default export */ var ProductOptions = __webpack_exports__["a"] = (Container);

/***/ }),

/***/ "Oq7K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ handleRemoveCartItem; });

// EXTERNAL MODULE: ./actionTypes/index.js
var actionTypes = __webpack_require__("ifZB");

// CONCATENATED MODULE: ./actions/removeCartItem.js

/**
 * removeCartItem
 *
 * @param {String} cartItemId Id of the cart item that should be romved
 * @returns {Object} Redux action
 */

var removeCartItem_removeCartItem = function removeCartItem(cartItemId) {
  return {
    type: actionTypes["l" /* REMOVE_CART_ITEM */],
    payload: cartItemId
  };
};

/* harmony default export */ var actions_removeCartItem = (removeCartItem_removeCartItem);
// EXTERNAL MODULE: ./actions/handleNotification.js + 2 modules
var handleNotification = __webpack_require__("SDM7");

// EXTERNAL MODULE: ./components/shared/Notifications/types.js
var types = __webpack_require__("qJix");

// EXTERNAL MODULE: ./components/wrappers/PageTracker/utils.ts + 1 modules
var utils = __webpack_require__("IUCn");

// EXTERNAL MODULE: ./utils/tracking/mergeUACategories.ts
var mergeUACategories = __webpack_require__("ZrlA");

// EXTERNAL MODULE: ./data/abstractProducts.js
var abstractProducts = __webpack_require__("eTmy");
var abstractProducts_default = /*#__PURE__*/__webpack_require__.n(abstractProducts);

// CONCATENATED MODULE: ./actions/handleRemoveCartItem.js






function handleRemoveCartItem(cartItemId) {
  return function thunk(dispatch, getState) {
    var state = getState(); // Get cart item

    var cartItem = state.entities.cartItems.byId[cartItemId];
    var currency = state.settings.currencyId;

    if (!cartItem) {
      return;
    } // Get variant


    var variant = state.entities.variants.byId[cartItem.variantId]; // Get product

    var product = state.entities.products.byId[variant.productId]; // Get and create categories string for product

    var productCategories = Object(mergeUACategories["a" /* default */])(abstractProducts_default.a.byId[product.handle].categories); // Remove fro, cart

    dispatch(actions_removeCartItem(cartItemId)); // Track remove from cart

    Object(utils["j" /* trackRemoveFromCart */])(currency, {
      name: product.title,
      id: variant.sku,
      price: variant.price ? parseFloat(variant.price) : null,
      compareAtPrice: variant.compareAtPrice ? parseFloat(variant.compareAtPrice) : null,
      variant: variant.title === 'Default Title' ? product.title : variant.title,
      category: productCategories
    });
    var message =
    /*i18n*/
    {
      id: "Removed {0}x {1} from cart.",
      values: {
        0: cartItem.quantity,
        1: product.title
      }
    };
    var payload = {
      variantId: cartItem.variantId,
      quantity: cartItem.quantity
    }; // Show alert message for 5 seconds

    dispatch(Object(handleNotification["a" /* default */])(types["a" /* CART_REMOVAL */], message, 5, payload));
  };
}

/***/ }),

/***/ "PhIz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@lingui/react/index.js
var react = __webpack_require__("ZD0w");

// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__("q1tI");
var node_modules_react_default = /*#__PURE__*/__webpack_require__.n(node_modules_react);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./styles/theme.js
var theme = __webpack_require__("NVT0");

// EXTERNAL MODULE: ./components/atoms/Link/index.tsx
var Link = __webpack_require__("ZT91");

// CONCATENATED MODULE: ./components/shared/TextLink/index.js
var __jsx = node_modules_react_default.a.createElement;




var TextLink_TextLink = function TextLink(_ref) {
  var type = _ref.type,
      text = _ref.text;
  var url = '';
  var textComponent = text;

  if (type === 'terms') {
    url = '/terms';
    textComponent = text || /*#__PURE__*/node_modules_react_default.a.createElement(react["Trans"], {
      id: "terms and conditions"
    });
  } else if (type === 'privacy') {
    url = '/privacy';
    textComponent = text || /*#__PURE__*/node_modules_react_default.a.createElement(react["Trans"], {
      id: "privacy policy"
    });
  }

  return /*#__PURE__*/node_modules_react_default.a.createElement(Link["a" /* default */], {
    href: url
  }, /*#__PURE__*/node_modules_react_default.a.createElement("a", null, textComponent));
};

TextLink_TextLink.defaultProps = {
  text: null
};
/* harmony default export */ var shared_TextLink = (TextLink_TextLink);
// EXTERNAL MODULE: ./components/atoms/FormElements/index.js + 13 modules
var FormElements = __webpack_require__("DAQc");

// EXTERNAL MODULE: ./components/atoms/Text/mixins/bodyTextMixins.js
var bodyTextMixins = __webpack_require__("hcoH");

// EXTERNAL MODULE: ./components/shared/Cart/NarrowCart/Checkout/layout/index.js + 2 modules
var layout = __webpack_require__("ohNE");

// CONCATENATED MODULE: ./components/shared/Cart/shared/Consent/index.js
var Consent_jsx = node_modules_react_default.a.createElement;









var Consent_Consent = function Consent(_ref) {
  var bgWhite = _ref.bgWhite,
      onChange = _ref.onChange,
      consentChecked = _ref.consentChecked,
      className = _ref.className,
      checkboxId = _ref.checkboxId;
  return /*#__PURE__*/node_modules_react_default.a.createElement(Wrapper, {
    bgWhite: bgWhite,
    className: className
  }, /*#__PURE__*/node_modules_react_default.a.createElement(ConsentText, {
    id: checkboxId,
    onChange: onChange,
    whiteText: true,
    checked: consentChecked,
    bgWhite: bgWhite
  }, /*#__PURE__*/node_modules_react_default.a.createElement(react["Trans"], {
    id: "I agree with the"
  }), ' ', /*#__PURE__*/node_modules_react_default.a.createElement(StyledTextLink, {
    type: "terms",
    bgWhite: bgWhite
  }), "."));
};

var Wrapper = Object(styled_components_browser_esm["default"])(layout["a" /* Row */]).withConfig({
  displayName: "Consent__Wrapper",
  componentId: "s4y8b-0"
})(["grid-template-columns:1fr;", ";color:", ";margin-top:", "px;margin-bottom:", "px;&:before,&:after{position:absolute;}@media ", "{margin:", "px 0;}"], bodyTextMixins["d" /* bodyTextMixin4 */], function (props) {
  return props.bgWhite ? theme["a" /* default */].colors.black : theme["a" /* default */].colors.white;
}, theme["a" /* default */].baseline * 2, theme["a" /* default */].baseline * 2, theme["a" /* default */].breakpoints.desktopLarge, theme["a" /* default */].halfBaseline * 5);
var ConsentText = Object(styled_components_browser_esm["default"])(FormElements["a" /* Checkbox */]).withConfig({
  displayName: "Consent__ConsentText",
  componentId: "s4y8b-1"
})(["label{margin-bottom:0;div:first-child{min-width:116px;}}@media ", "{padding-left:0;}"], theme["a" /* default */].breakpoints.tablet);
var StyledTextLink = Object(styled_components_browser_esm["default"])(function (props) {
  return /*#__PURE__*/node_modules_react_default.a.createElement(shared_TextLink, {
    type: props.type
  });
}).withConfig({
  displayName: "Consent__StyledTextLink",
  componentId: "s4y8b-2"
})(["color:", " !important;text-decoration:underline;"], function (props) {
  return props.bgWhite ? props.theme.colors.black : props.theme.colors.white;
});
Consent_Consent.defaultProps = {
  bgWhite: false,
  className: null
};
/* harmony default export */ var shared_Consent = __webpack_exports__["a"] = (Consent_Consent);

/***/ }),

/***/ "RN8+":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/png;base64,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" };

/***/ }),

/***/ "a7li":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/png;base64,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" };

/***/ }),

/***/ "dOrG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./data/regions.js
var regions = __webpack_require__("keR7");
var regions_default = /*#__PURE__*/__webpack_require__.n(regions);

// EXTERNAL MODULE: ./data/shops.js
var shops = __webpack_require__("z1id");
var shops_default = /*#__PURE__*/__webpack_require__.n(shops);

// EXTERNAL MODULE: ./data/currencies.js
var currencies = __webpack_require__("BP0X");

// EXTERNAL MODULE: ./node_modules/@lingui/react/index.js
var react = __webpack_require__("ZD0w");

// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__("q1tI");
var node_modules_react_default = /*#__PURE__*/__webpack_require__.n(node_modules_react);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./components/atoms/Text/mixins/bodyTextMixins.js
var bodyTextMixins = __webpack_require__("hcoH");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Skeleton/index.tsx
var Skeleton = __webpack_require__("OWaX");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/styles/theme.ts
var theme = __webpack_require__("isV7");

// CONCATENATED MODULE: ./components/pages/Products/Product/ProductPrice/Component.js
var __jsx = node_modules_react_default.a.createElement;







var Component_PriceFormat = function PriceFormat(_ref) {
  var price = _ref.price,
      currencyCode = _ref.currencyCode;
  return /*#__PURE__*/node_modules_react_default.a.createElement(react["NumberFormat"], {
    value: price,
    format: {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  });
};

var Component_ProductPrice = function ProductPrice(_ref2) {
  var quantity = _ref2.quantity,
      currencyCode = _ref2.currencyCode,
      price = _ref2.price,
      oldPrice = _ref2.oldPrice,
      black = _ref2.black,
      className = _ref2.className;
  return /*#__PURE__*/node_modules_react_default.a.createElement(PriceWrapper, {
    quantity: quantity,
    className: className
  }, /*#__PURE__*/node_modules_react_default.a.createElement(MainPrice, null, oldPrice && /*#__PURE__*/node_modules_react_default.a.createElement(OldPrice, {
    oldPrice: oldPrice,
    black: black
  }, /*#__PURE__*/node_modules_react_default.a.createElement(Component_PriceFormat, {
    price: oldPrice,
    currencyCode: currencyCode
  })), !price ? /*#__PURE__*/node_modules_react_default.a.createElement(Skeleton["a" /* Skeleton */], {
    width: theme["j" /* Size */].BaseUnit * 13,
    height: theme["j" /* Size */].BaseUnit * 3,
    radius: 4
  }) : /*#__PURE__*/node_modules_react_default.a.createElement(Price, {
    oldPrice: oldPrice
  }, /*#__PURE__*/node_modules_react_default.a.createElement(Component_PriceFormat, {
    price: price,
    currencyCode: currencyCode
  }))));
};

var PriceWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Component__PriceWrapper",
  componentId: "e05p4x-0"
})(["display:flex;justify-content:center;"]);
var MainPrice = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Component__MainPrice",
  componentId: "e05p4x-1"
})(["display:flex;flex-flow:column wrap;> div:nth-child(2){margin-top:", "px;}"], function (props) {
  return props.theme.baseline;
});
var OldPrice = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Component__OldPrice",
  componentId: "e05p4x-2"
})(["", ";font-weight:bold;color:", ";text-decoration:line-through;text-decoration-color:", ";"], bodyTextMixins["c" /* bodyTextMixin3 */], function (props) {
  return props.black ? props.theme.colors.black : props.theme.colors.white;
}, function (props) {
  return props.theme.colors.primary;
});
var Price = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Component__Price",
  componentId: "e05p4x-3"
})(["", ";font-weight:bold;color:", ";text-decoration:none !important;"], bodyTextMixins["c" /* bodyTextMixin3 */], function (props) {
  return props.oldPrice ? props.theme.colors.primary : props.theme.colors.black;
});
Component_ProductPrice.defaultProps = {
  oldPrice: null,
  quantity: 1,
  black: false,
  className: ''
};
/* harmony default export */ var Component = (Component_ProductPrice);
// CONCATENATED MODULE: ./components/pages/Products/Product/ProductPrice/Container.js




 // mapStateToProps

var Container_mapStateToProps = function mapStateToProps(state, props) {
  var quantity = props.quantity,
      variantPrice = props.variantPrice,
      variantcompareAtPrice = props.variantcompareAtPrice;
  var regionId = state.settings.regionId;
  var shopId = regions_default.a.byId[regionId].shopId;
  var currencyId = shops_default.a.byId[shopId].currencyId;
  var currency = currencies["a" /* default */].byId[currencyId];
  var price = quantity * parseFloat(variantPrice);
  var oldPrice = variantcompareAtPrice && quantity * parseFloat(variantcompareAtPrice);
  return {
    currencyCode: currency.code,
    price: price,
    oldPrice: oldPrice
  };
}; // Connect to Redux


var ProductPriceContainer = Object(es["b" /* connect */])(Container_mapStateToProps)(Component);
/* harmony default export */ var Container = (ProductPriceContainer);
// CONCATENATED MODULE: ./components/pages/Products/Product/ProductPrice/index.js

/* harmony default export */ var Product_ProductPrice = __webpack_exports__["a"] = (Container);

/***/ }),

/***/ "fE6x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ NarrowCart["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ WideCart; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ Cart_EmptyCart; });

// EXTERNAL MODULE: ./components/shared/Cart/NarrowCart/index.js + 20 modules
var NarrowCart = __webpack_require__("2VYq");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("Ff2n");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("1OyB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("vuIU");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("JX7q");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("Ji7U");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("md7G");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("foSv");

// EXTERNAL MODULE: ./actions/handleAddCartItem.js + 1 modules
var handleAddCartItem = __webpack_require__("2OoW");

// EXTERNAL MODULE: ./data/regions.js
var regions = __webpack_require__("keR7");
var regions_default = /*#__PURE__*/__webpack_require__.n(regions);

// EXTERNAL MODULE: ./node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__("ZD0w");

// EXTERNAL MODULE: ./components/atoms/Text/index.js + 17 modules
var Text = __webpack_require__("wCgk");

// CONCATENATED MODULE: ./components/shared/Cart/shared/UpsellBackpack/Component.js

var __jsx = react_default.a.createElement;




var UpsellBackpack = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Component__UpsellBackpack",
  componentId: "t9u52d-0"
})(["padding:", "px 0;background-color:", ";text-align:center;border-radius:", ";margin:", "px 0;@media ", "{padding:", "px 0;margin:", "px 0;}"], function (props) {
  return props.theme.baseline * 2;
}, function (props) {
  return props.theme.colors.grey3;
}, function (props) {
  return props.theme.sizes.radius;
}, function (props) {
  return props.theme.halfBaseline * 10;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.baseline * 4;
}, function (props) {
  return props.theme.halfBaseline * 10;
});
var TextWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Component__TextWrapper",
  componentId: "t9u52d-1"
})(["width:", "px;margin:auto;@media ", "{width:", "px;}"], function (props) {
  return props.theme.baseline * 26;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.baseline * 34;
});
var Component_Text = Object(styled_components_browser_esm["default"])(Text["j" /* MenuText */]).withConfig({
  displayName: "Component__Text",
  componentId: "t9u52d-2"
})(["text-transform:uppercase;margin-right:", "px;"], function (props) {
  return props.theme.halfBaseline;
});
var CTA = Object(styled_components_browser_esm["default"])(Component_Text).withConfig({
  displayName: "Component__CTA",
  componentId: "t9u52d-3"
})(["cursor:pointer;color:", ";display:contents;text-decoration:underline;"], function (props) {
  return props.theme.colors.primary;
});

var Component_Component = function Component(_ref) {
  var show = _ref.show,
      handleAddBackpackClick = _ref.handleAddBackpackClick,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["show", "handleAddBackpackClick"]);

  return show && /*#__PURE__*/react_default.a.createElement(UpsellBackpack, {
    className: rest.className
  }, /*#__PURE__*/react_default.a.createElement(TextWrapper, null, /*#__PURE__*/react_default.a.createElement(Component_Text, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.cart.upsell.message"
  })), /*#__PURE__*/react_default.a.createElement(CTA, {
    onClick: handleAddBackpackClick
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.cart.upsell.backpack"
  }))));
}; // PropTypes


/* harmony default export */ var UpsellBackpack_Component = (Component_Component);
// CONCATENATED MODULE: ./components/shared/Cart/shared/UpsellBackpack/Container.js







var Container_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var Container_ConnectedUpsellBackpackContainer = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(ConnectedUpsellBackpackContainer, _Component);

  var _super = _createSuper(ConnectedUpsellBackpackContainer);

  /**
   * @constructor
   * @desc handleAddBackpackClick: pass as prop to child component
   */
  function ConnectedUpsellBackpackContainer(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ConnectedUpsellBackpackContainer);

    _this = _super.call(this, props);
    _this.handleAddBackpackClick = _this.handleAddBackpackClick.bind(Object(assertThisInitialized["a" /* default */])(_this));
    return _this;
  }
  /**
   * @desc on Backpack button click, dispatch redux action
   */


  Object(createClass["a" /* default */])(ConnectedUpsellBackpackContainer, [{
    key: "handleAddBackpackClick",
    value: function handleAddBackpackClick() {
      var _this$props = this.props,
          addItemToCart = _this$props.addItemToCart,
          backpackVariantId = _this$props.backpackVariantId;
      addItemToCart(backpackVariantId);
    }
    /**
     * @returns {JSX}
     */

  }, {
    key: "render",
    value: function render() {
      var rest = Object(esm_extends["a" /* default */])({}, this.props);

      return /*#__PURE__*/react_default.a.createElement(UpsellBackpack_Component, {
        handleAddBackpackClick: this.handleAddBackpackClick,
        show: rest.show,
        className: rest.className
      });
    }
  }]);

  return ConnectedUpsellBackpackContainer;
}(react["Component"]); // PropTypes


Container_ConnectedUpsellBackpackContainer.defaultProps = {
  backpackVariantId: null
}; // PropTypes

var Container_mapStateToProps = function mapStateToProps(state) {
  var _state$entities = state.entities,
      cartItems = _state$entities.cartItems,
      variants = _state$entities.variants,
      products = _state$entities.products;
  var regionId = state.settings.regionId;
  var shopId = regions_default.a.byId[regionId].shopId;
  var variantId;
  var productId;
  var handle; // Check if backpack in cart

  var backpackInCart = cartItems.allIds.find(function (cartItemId) {
    variantId = cartItems.byId[cartItemId].variantId;
    productId = variants.byId[variantId].productId;
    handle = products.byId[productId].handle;
    return handle === 'backpack';
  }); // Check if CarrierStrap in cart

  var carrierStrapInCart = cartItems.allIds.find(function (cartItemId) {
    variantId = cartItems.byId[cartItemId].variantId;
    productId = variants.byId[variantId].productId;
    handle = products.byId[productId].handle;
    return handle === 'carrier-strap';
  }); // Check if Soundboks Go in cart

  var soundboksGoInCart = cartItems.allIds.find(function (cartItemId) {
    variantId = cartItems.byId[cartItemId].variantId;
    productId = variants.byId[variantId].productId;
    handle = products.byId[productId].handle;
    return handle === 'soundboks-go';
  }); // Find backpack product id

  var backpackId = products.allIds.find(function (id) {
    return products.byId[id].handle === 'backpack' && shopId === products.byId[id].shopId;
  }); // Get backpack variant id

  var backpackVariantId = backpackId ? products.byId[backpackId].variantIds[0] : undefined; // Check availability

  var isInStock = variants.byId[backpackVariantId] && variants.byId[backpackVariantId].available; // If it's not in cart, if it exists and in stock, show backpack option

  var show = !!(!backpackInCart && !carrierStrapInCart && !soundboksGoInCart && backpackVariantId && isInStock);
  return {
    show: show,
    backpackVariantId: backpackVariantId
  };
}; // mapDispatchToProps


var Container_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    addItemToCart: function addItemToCart(variantId) {
      dispatch(Object(handleAddCartItem["a" /* default */])(variantId, 1));
    }
  };
}; // Connect


var UpsellBackpackContainer = Object(es["b" /* connect */])(Container_mapStateToProps, Container_mapDispatchToProps)(Container_ConnectedUpsellBackpackContainer);
/* harmony default export */ var Container = (UpsellBackpackContainer);
// CONCATENATED MODULE: ./components/shared/Cart/shared/UpsellBackpack/index.js

/* harmony default export */ var shared_UpsellBackpack = (Container);
// CONCATENATED MODULE: ./components/shared/Cart/WideCart/UpsellExtraBattery/index.js


var UpsellExtraBattery_Component = Object(styled_components_browser_esm["default"])(shared_UpsellBackpack).withConfig({
  displayName: "UpsellExtraBattery__Component",
  componentId: "o8i6it-0"
})(["@media ", "{> div{width:", "px;span{font-size:", "px;}}}"], function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.baseline * 66;
}, function (props) {
  return props.theme.baseline * 4;
});
/* harmony default export */ var UpsellExtraBattery = (UpsellExtraBattery_Component);
// EXTERNAL MODULE: ./utils/convertToCurrency.js
var convertToCurrency = __webpack_require__("+YIU");

// EXTERNAL MODULE: ./data/shops.js
var shops = __webpack_require__("z1id");
var shops_default = /*#__PURE__*/__webpack_require__.n(shops);

// EXTERNAL MODULE: ./data/productImages.js
var productImages = __webpack_require__("GQ8G");
var productImages_default = /*#__PURE__*/__webpack_require__.n(productImages);

// EXTERNAL MODULE: ./data/abstractProducts.js
var abstractProducts = __webpack_require__("eTmy");
var abstractProducts_default = /*#__PURE__*/__webpack_require__.n(abstractProducts);

// EXTERNAL MODULE: ./actions/changeCartItemQuantity.js
var changeCartItemQuantity = __webpack_require__("43V8");

// EXTERNAL MODULE: ./actions/handleRemoveCartItem.js + 1 modules
var handleRemoveCartItem = __webpack_require__("Oq7K");

// EXTERNAL MODULE: ./components/atoms/Link/index.tsx
var Link = __webpack_require__("ZT91");

// CONCATENATED MODULE: ./components/shared/Cart/WideCart/CartItem/ProductImage/index.js
var ProductImage_jsx = react_default.a.createElement;


 // StyledProductImage

var StyledProductImage = styled_components_browser_esm["default"].a.withConfig({
  displayName: "ProductImage__StyledProductImage",
  componentId: "sc-15yollf-0"
})(["margin:", ";display:flex;img{align-self:center;display:inline-block;max-width:", "px;max-height:", "px;}@media ", "{max-width:", "px;max-height:", "px;margin:", ";}"], function (props) {
  return props.theme.space.inline.m;
}, function (props) {
  return props.theme.baseline * 13;
}, function (props) {
  return props.theme.baseline * 15;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.baseline * 21;
}, function (props) {
  return props.theme.baseline * 21;
}, function (props) {
  return props.theme.space.inline.l;
}); // ProductImage

var ProductImage_ProductImage = function ProductImage(_ref) {
  var title = _ref.title,
      link = _ref.link,
      imageUrl = _ref.imageUrl;
  return /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: link.href,
    as: link.as,
    passHref: true
  }, /*#__PURE__*/react_default.a.createElement(StyledProductImage, null, /*#__PURE__*/react_default.a.createElement("img", {
    src: "".concat(imageUrl, "?height=120"),
    alt: title
  })));
}; // PropTypes


/* harmony default export */ var CartItem_ProductImage = (ProductImage_ProductImage);
// EXTERNAL MODULE: ./styles/theme.js
var theme = __webpack_require__("NVT0");

// EXTERNAL MODULE: ./components/shared/Cart/shared/ProductQuantity/index.js + 4 modules
var ProductQuantity = __webpack_require__("H9RR");

// EXTERNAL MODULE: ./components/shared/Cart/shared/SubTitle/index.js
var SubTitle = __webpack_require__("2CxJ");

// CONCATENATED MODULE: ./components/shared/Cart/WideCart/CartItem/ProductInfo/Title/index.js
var Title_jsx = react_default.a.createElement;



 // StyledTitle

var StyledTitle = styled_components_browser_esm["default"].a.withConfig({
  displayName: "Title__StyledTitle",
  componentId: "sc-1z0osbl-0"
})(["color:", ";&:hover{text-decoration:none;}h2{@media ", "{display:block;font-size:", "px;}@media ", "{font-size:", "px;}}"], function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.halfBaseline * 5;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.halfBaseline * 7;
}); // Title

var Title_Title = function Title(_ref) {
  var title = _ref.title,
      link = _ref.link;
  return /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: link.href,
    as: link.as,
    passHref: true
  }, /*#__PURE__*/react_default.a.createElement(StyledTitle, null, /*#__PURE__*/react_default.a.createElement(Text["d" /* H2 */], null, title)));
}; // PropTypes


/* harmony default export */ var ProductInfo_Title = (Title_Title);
// EXTERNAL MODULE: ./components/pages/Products/Product/ProductPrice/index.js + 2 modules
var ProductPrice = __webpack_require__("dOrG");

// EXTERNAL MODULE: ./components/atoms/Text/mixins/bodyTextMixins.js
var bodyTextMixins = __webpack_require__("hcoH");

// CONCATENATED MODULE: ./components/shared/Cart/WideCart/CartItem/ProductInfo/ProductPrice/index.js



var ProductPrice_ProductPrice = Object(styled_components_browser_esm["default"])(ProductPrice["a" /* default */]).withConfig({
  displayName: "ProductPrice",
  componentId: "rx01cd-0"
})(["width:", "px;height:", "px;margin:auto 0;font-weight:bold;flex-flow:column;align-items:flex-start;> div:first-child{", ";margin-bottom:", "px;> div:nth-child(2){margin-left:", "px;}}> div:last-child{", ";font-weight:normal;text-align:left;}"], function (props) {
  return props.theme.halfBaseline * 37;
}, function (props) {
  return props.theme.halfBaseline * 13;
}, bodyTextMixins["b" /* bodyTextMixin2 */], function (props) {
  return props.theme.baseline;
}, function (props) {
  return props.theme.baseline;
}, bodyTextMixins["d" /* bodyTextMixin4 */]);
/* harmony default export */ var ProductInfo_ProductPrice = (ProductPrice_ProductPrice);
// EXTERNAL MODULE: ./components/shared/Cart/shared/RemoveCartItem/index.js
var RemoveCartItem = __webpack_require__("AfKe");

// CONCATENATED MODULE: ./components/shared/Cart/WideCart/CartItem/ProductInfo/RemoveItem/index.js


var RemoveItem_Component = Object(styled_components_browser_esm["default"])(RemoveCartItem["a" /* default */]).withConfig({
  displayName: "RemoveItem__Component",
  componentId: "sc-1o7n3rm-0"
})(["position:absolute;top:0;right:0;height:auto;"]);
/* harmony default export */ var RemoveItem = (RemoveItem_Component);
// EXTERNAL MODULE: ./components/shared/Cart/shared/ProductOptions/index.js + 4 modules
var ProductOptions = __webpack_require__("HOtW");

// CONCATENATED MODULE: ./components/shared/Cart/WideCart/CartItem/ProductInfo/Options/index.js



var StyledOptions = Object(styled_components_browser_esm["default"])(ProductOptions["a" /* default */]).withConfig({
  displayName: "Options__StyledOptions",
  componentId: "oqc0j3-0"
})(["font-weight:bold;max-width:", "px;@media ", "{margin-top:", "px;}@media ", "{max-width:", "px;}"], theme["a" /* default */].baseline * 25, theme["a" /* default */].breakpoints.tablet, theme["a" /* default */].baseline, theme["a" /* default */].breakpoints.desktopLarge, theme["a" /* default */].baseline * 35);
/* harmony default export */ var Options = (StyledOptions);
// CONCATENATED MODULE: ./components/shared/Cart/WideCart/CartItem/ProductInfo/index.js
var ProductInfo_jsx = react_default.a.createElement;





 // import InStock from './InStock';



 // ProductInfo

var ProductInfo_ProductInfo = function ProductInfo(_ref) {
  var cartItemId = _ref.cartItemId,
      title = _ref.title,
      link = _ref.link,
      quantity = _ref.quantity,
      handleRemoveClick = _ref.handleRemoveClick,
      handleDecreaseQuantityClick = _ref.handleDecreaseQuantityClick,
      handleIncreaseQuantityClick = _ref.handleIncreaseQuantityClick,
      variantIds = _ref.variantIds,
      optionIds = _ref.optionIds,
      handle = _ref.handle;
  return /*#__PURE__*/react_default.a.createElement(Wrapper, null, /*#__PURE__*/react_default.a.createElement(Description, null, /*#__PURE__*/react_default.a.createElement(SubTitle["a" /* default */], {
    handle: handle
  }), /*#__PURE__*/react_default.a.createElement(ProductInfo_Title, {
    title: title,
    link: link
  }), /*#__PURE__*/react_default.a.createElement(Options, {
    cartItemId: cartItemId,
    variantIds: variantIds,
    optionIds: optionIds
  })), /*#__PURE__*/react_default.a.createElement(Quantity, {
    quantity: quantity,
    handleDecreaseQuantityClick: handleDecreaseQuantityClick,
    handleIncreaseQuantityClick: handleIncreaseQuantityClick,
    cartItemId: cartItemId
  }), /*#__PURE__*/react_default.a.createElement(Price, {
    cartItemId: cartItemId,
    quantity: quantity,
    localPrice: true,
    black: true
  }), /*#__PURE__*/react_default.a.createElement(RemoveItem, {
    handleRemoveClick: handleRemoveClick,
    cartItemId: cartItemId
  }));
}; // Wrapper


var Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductInfo__Wrapper",
  componentId: "sc-1p2t6lm-0"
})(["visibility:visible;display:flex;flex-grow:100;position:relative;padding-right:", "px;", "{height:", "px;}"], theme["a" /* default */].baseline * 4, theme["a" /* default */].breakpoints.tablet, theme["a" /* default */].halfBaseline * 37);
var Description = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductInfo__Description",
  componentId: "sc-1p2t6lm-1"
})(["float:left;margin:auto 0;width:52%;"]);
var Quantity = Object(styled_components_browser_esm["default"])(ProductQuantity["b" /* WideQuantity */]).withConfig({
  displayName: "ProductInfo__Quantity",
  componentId: "sc-1p2t6lm-2"
})(["width:22%;"]);
var Price = Object(styled_components_browser_esm["default"])(ProductInfo_ProductPrice).withConfig({
  displayName: "ProductInfo__Price",
  componentId: "sc-1p2t6lm-3"
})(["width:26%;"]); // PropTypes

/* harmony default export */ var CartItem_ProductInfo = (ProductInfo_ProductInfo);
// CONCATENATED MODULE: ./components/shared/Cart/WideCart/CartItem/Component.js
var Component_jsx = react_default.a.createElement;



 // Item

var Component_Item = function Item(_ref) {
  var cartItemId = _ref.cartItemId,
      available = _ref.available,
      title = _ref.title,
      handle = _ref.handle,
      link = _ref.link,
      pricesIncludeVAT = _ref.pricesIncludeVAT,
      currencyCode = _ref.currencyCode,
      price = _ref.price,
      quantity = _ref.quantity,
      handleRemoveClick = _ref.handleRemoveClick,
      handleDecreaseQuantityClick = _ref.handleDecreaseQuantityClick,
      handleIncreaseQuantityClick = _ref.handleIncreaseQuantityClick,
      variantIds = _ref.variantIds,
      imageUrl = _ref.imageUrl,
      optionIds = _ref.optionIds;
  return /*#__PURE__*/react_default.a.createElement(Component_Wrapper, null, /*#__PURE__*/react_default.a.createElement(CartItem_ProductImage, {
    link: link,
    title: title,
    imageUrl: imageUrl
  }), /*#__PURE__*/react_default.a.createElement(CartItem_ProductInfo, {
    cartItemId: cartItemId,
    available: available,
    title: title,
    handle: handle,
    link: link,
    pricesIncludeVAT: pricesIncludeVAT,
    currencyCode: currencyCode,
    price: price,
    quantity: quantity,
    variantIds: variantIds,
    optionIds: optionIds,
    handleRemoveClick: handleRemoveClick,
    handleDecreaseQuantityClick: handleDecreaseQuantityClick,
    handleIncreaseQuantityClick: handleIncreaseQuantityClick
  }));
}; // PropTypes


// Wrapper
var Component_Wrapper = styled_components_browser_esm["default"].li.withConfig({
  displayName: "Component__Wrapper",
  componentId: "sc-1818b83-0"
})(["width:100%;margin:", ";list-style-type:none;display:flex;@media ", "{box-shadow:0 1px 7px rgba(0,0,0,0.15);padding:", ";border-radius:3px;}:after{content:'.';visibility:hidden;display:block;height:0;clear:both;}"], function (props) {
  return props.theme.space.stack.l;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.space.inset.m;
});
/* harmony default export */ var CartItem_Component = (Component_Item);
// CONCATENATED MODULE: ./components/shared/Cart/WideCart/CartItem/Container.js
var CartItem_Container_jsx = react_default.a.createElement;








 // Container

var Container_ConnectedItemContainer = function ConnectedItemContainer(_ref) {
  var cartItemId = _ref.cartItemId,
      available = _ref.available,
      title = _ref.title,
      link = _ref.link,
      pricesIncludeVAT = _ref.pricesIncludeVAT,
      currencyCode = _ref.currencyCode,
      price = _ref.price,
      quantity = _ref.quantity,
      handleRemoveClick = _ref.handleRemoveClick,
      handleDecreaseQuantityClick = _ref.handleDecreaseQuantityClick,
      handleIncreaseQuantityClick = _ref.handleIncreaseQuantityClick,
      variantIds = _ref.variantIds,
      imageUrl = _ref.imageUrl,
      optionIds = _ref.optionIds;
  return /*#__PURE__*/react_default.a.createElement(CartItem_Component, {
    cartItemId: cartItemId,
    available: available,
    title: title,
    link: link,
    pricesIncludeVAT: pricesIncludeVAT,
    currencyCode: currencyCode,
    price: price,
    quantity: quantity,
    variantIds: variantIds,
    optionIds: optionIds,
    imageUrl: imageUrl,
    handleRemoveClick: handleRemoveClick,
    handleDecreaseQuantityClick: handleDecreaseQuantityClick,
    handleIncreaseQuantityClick: handleIncreaseQuantityClick
  });
};

// mapStateToProps
var CartItem_Container_mapStateToProps = function mapStateToProps(state, props) {
  var entities = state.entities;
  var cartItem = entities.cartItems.byId[props.cartItemId];
  var variant = entities.variants.byId[cartItem.variantId];
  var product = entities.products.byId[variant.productId];
  var shop = shops_default.a.byId[product.shopId];
  var shopCurrencyCode = shop.currencyId;
  var currencyCode = state.settings.currencyId;
  var variantIds = product.variantIds,
      optionIds = product.optionIds,
      handle = product.handle; // Get image url

  var imageUrl = '';
  var abstractProduct = abstractProducts_default.a.byId[product.handle];

  if (abstractProduct) {
    var imageId = abstractProduct.productImageIds[0];
    imageUrl = productImages_default.a.byId[imageId].url;
  }

  var price = parseFloat(variant.price);
  price = parseFloat(Object(convertToCurrency["a" /* default */])(price, shopCurrencyCode, currencyCode));
  return {
    available: variant.available,
    title: product.title,
    handle: handle,
    quantity: cartItem.quantity,
    price: price,
    currencyCode: currencyCode,
    pricesIncludeVAT: shop.pricesIncludeVAT,
    variantIds: variantIds,
    optionIds: optionIds,
    imageUrl: imageUrl,
    link: {
      href: "/products/product?productHandle=".concat(product.handle),
      as: "/products/".concat(product.handle)
    }
  };
}; // MapDispatchToProps


var CartItem_Container_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleDecreaseQuantityClick: function handleDecreaseQuantityClick(event) {
      dispatch(Object(changeCartItemQuantity["a" /* default */])(event.currentTarget.getAttribute('data-id'), -1));
    },
    handleIncreaseQuantityClick: function handleIncreaseQuantityClick(event) {
      dispatch(Object(changeCartItemQuantity["a" /* default */])(event.currentTarget.getAttribute('data-id'), 1));
    },
    handleRemoveClick: function handleRemoveClick(event) {
      dispatch(Object(handleRemoveCartItem["a" /* default */])(event.currentTarget.getAttribute('data-id')));
    }
  };
}; // Connect to Redux


var ItemContainer = Object(es["b" /* connect */])(CartItem_Container_mapStateToProps, CartItem_Container_mapDispatchToProps)(Container_ConnectedItemContainer);
/* harmony default export */ var CartItem_Container = (ItemContainer);
// CONCATENATED MODULE: ./components/shared/Cart/WideCart/CartItem/index.js

/* harmony default export */ var CartItem = (CartItem_Container);
// EXTERNAL MODULE: ./actions/handleCheckoutProcess.jsx + 2 modules
var handleCheckoutProcess = __webpack_require__("6nWa");

// EXTERNAL MODULE: ./components/shared/Notifications/types.js
var types = __webpack_require__("qJix");

// EXTERNAL MODULE: ./actions/handleNotification.js + 2 modules
var handleNotification = __webpack_require__("SDM7");

// EXTERNAL MODULE: ./components/shared/Cart/shared/Consent/index.js + 1 modules
var Consent = __webpack_require__("PhIz");

// CONCATENATED MODULE: ./components/shared/Cart/shared/ShippingText/index.js
var ShippingText_jsx = react_default.a.createElement;



 // StyledShippingText

var StyledShippingText = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ShippingText__StyledShippingText",
  componentId: "rdqjsf-0"
})(["", ";display:none;visibility:hidden;text-transform:uppercase;font-weight:bold;@media ", "{display:inline-block;visibility:visible;margin-top:", "px;margin-bottom:0;}@media ", "{margin:", ";}"], bodyTextMixins["c" /* bodyTextMixin3 */], function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.halfBaseline * 6;
}, function (props) {
  return props.theme.breakpoints.desktop;
}, function (props) {
  return props.theme.space.stack.l;
}); // ShippingText

var ShippingText_ShippingText = function ShippingText() {
  return /*#__PURE__*/react_default.a.createElement(StyledShippingText, {
    bold: true
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Free shipping to<0/>continental USA and Canada.",
    components: [/*#__PURE__*/react_default.a.createElement("br", null)]
  }));
};

/* harmony default export */ var shared_ShippingText = (ShippingText_ShippingText);
// EXTERNAL MODULE: ./components/atoms/Button/index.js + 7 modules
var Button = __webpack_require__("8BE4");

// CONCATENATED MODULE: ./components/shared/Cart/WideCart/Checkout/CartButtons/index.js
var CartButtons_jsx = react_default.a.createElement;





var CartButtons_CartButtons = function CartButtons(_ref) {
  var onCheckoutClick = _ref.onCheckoutClick,
      checkoutLoading = _ref.checkoutLoading;
  return /*#__PURE__*/react_default.a.createElement(StyledCartButtons, null, /*#__PURE__*/react_default.a.createElement(CartButton, {
    id: "cart-cartPage__button--checkout",
    onClick: onCheckoutClick,
    isLoading: checkoutLoading,
    fixedWidth: true
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Check out"
  })));
};

var StyledCartButtons = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CartButtons__StyledCartButtons",
  componentId: "dqb3mk-0"
})(["display:flex;justify-content:center;align-items:center;width:100%;margin:", "px 0;padding:0 ", "px;@media ", "{width:50%;flex-flow:column;margin:0;}@media ", "{margin:", "px 0;padding:0 ", "px;}"], function (props) {
  return props.theme.halfBaseline * 5;
}, function (props) {
  return props.theme.halfBaseline * 5;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.halfBaseline * 8;
}, function (props) {
  return props.theme.halfBaseline * 8;
});
var CartButton = Object(styled_components_browser_esm["default"])(Button["c" /* PrimaryShopButton */]).withConfig({
  displayName: "CartButtons__CartButton",
  componentId: "dqb3mk-1"
})(["width:100%;margin:auto;@media ", "{margin-right:0;margin-bottom:", "px;width:", "px;}@media ", "{margin-left:0;margin-right:auto;width:100%;min-width:100%;padding:0;}"], function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.baseline * 3;
}, function (props) {
  return props.theme.halfBaseline * 45;
}, function (props) {
  return props.theme.breakpoints.desktop;
});
/* harmony default export */ var Checkout_CartButtons = (CartButtons_CartButtons);
// EXTERNAL MODULE: ./components/shared/Cart/shared/TotalPrice/index.js + 2 modules
var TotalPrice = __webpack_require__("hxB5");

// EXTERNAL MODULE: ./components/shared/ProductVAT/index.js
var ProductVAT = __webpack_require__("OCh6");

// CONCATENATED MODULE: ./components/shared/Cart/WideCart/Checkout/CartPrice/index.js
var CartPrice_jsx = react_default.a.createElement;









var CartPrice_CartPrice = function CartPrice(_ref) {
  var pricesIncludeVAT = _ref.pricesIncludeVAT;
  return /*#__PURE__*/react_default.a.createElement(CartPrice_Wrapper, null, /*#__PURE__*/react_default.a.createElement(TextRow, null, /*#__PURE__*/react_default.a.createElement(TextBlock, null, /*#__PURE__*/react_default.a.createElement(CartPrice_Text, {
    bold: true
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Total"
  })), pricesIncludeVAT && /*#__PURE__*/react_default.a.createElement(StyledProductVAT, null)), /*#__PURE__*/react_default.a.createElement(StyledTotalPrice, {
    showLocal: true
  })));
};

var StyledProductVAT = Object(styled_components_browser_esm["default"])(ProductVAT["a" /* default */]).withConfig({
  displayName: "CartPrice__StyledProductVAT",
  componentId: "sc-1w2wwnr-0"
})(["margin-top:", "px;"], theme["a" /* default */].baseline);
var CartPrice_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CartPrice__Wrapper",
  componentId: "sc-1w2wwnr-1"
})(["display:flex;flex-flow:column;padding:0 ", "px;@media ", "{width:50%;height:100%;float:left;justify-content:center;}@media ", "{margin-bottom:", "px !important;}@media ", "{margin-bottom:", "px !important;}"], theme["a" /* default */].halfBaseline * 5, theme["a" /* default */].breakpoints.tablet, theme["a" /* default */].breakpoints.desktop, theme["a" /* default */].baseline * 5, theme["a" /* default */].breakpoints.desktopLarge, theme["a" /* default */].baseline * 7);
var StyledTotalPrice = Object(styled_components_browser_esm["default"])(TotalPrice["a" /* default */]).withConfig({
  displayName: "CartPrice__StyledTotalPrice",
  componentId: "sc-1w2wwnr-2"
})(["> div:nth-child(1){", ";font-family:", ";margin-bottom:", "px;@media ", "{text-align:left;}}> div:nth-child(2){", ";@media ", "{display:none;}}"], bodyTextMixins["b" /* bodyTextMixin2 */], theme["a" /* default */].fonts.main, theme["a" /* default */].halfBaseline, theme["a" /* default */].breakpoints.tablet, bodyTextMixins["c" /* bodyTextMixin3 */], theme["a" /* default */].breakpoints.onlyTablet);
var TextBlock = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CartPrice__TextBlock",
  componentId: "sc-1w2wwnr-3"
})(["display:flex;flex-flow:column;align-items:flex-start;margin-bottom:", "px;small{margin-left:", "px;color:", " !important;}@media ", "{display:none;}@media ", "{display:flex;}@media ", "{small{font-size:", "px;}}"], theme["a" /* default */].baseline, theme["a" /* default */].halfBaseline, theme["a" /* default */].colors.grey, theme["a" /* default */].breakpoints.tablet, theme["a" /* default */].breakpoints.desktop, theme["a" /* default */].breakpoints.desktop, theme["a" /* default */].halfBaseline * 3);
var TextRow = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CartPrice__TextRow",
  componentId: "sc-1w2wwnr-4"
})(["position:relative;display:flex;justify-content:space-between;margin-bottom:", "px;@media ", "{flex-flow:column;margin-bottom:", "px;}@media ", "{margin-bottom:0;}"], theme["a" /* default */].baseline, theme["a" /* default */].breakpoints.tablet, theme["a" /* default */].baseline * 3, theme["a" /* default */].breakpoints.tablet);
var CartPrice_Text = Object(styled_components_browser_esm["default"])(Text["m" /* SubmenuNavigationText */]).withConfig({
  displayName: "CartPrice__Text",
  componentId: "sc-1w2wwnr-5"
})(["color:", ";font-size:", "px;font-weight:normal;@media ", "{font-size:", "px;}"], theme["a" /* default */].colors.black, theme["a" /* default */].halfBaseline * 3, theme["a" /* default */].breakpoints.desktopLarge, theme["a" /* default */].halfBaseline * 4);
/* harmony default export */ var Checkout_CartPrice = (CartPrice_CartPrice);
// EXTERNAL MODULE: ./components/shared/Cart/shared/PaymentOptions/index.js
var PaymentOptions = __webpack_require__("uAAP");

// CONCATENATED MODULE: ./components/shared/Cart/WideCart/Checkout/PaymentOptions/index.js



var PaymentOptions_Component = Object(styled_components_browser_esm["default"])(PaymentOptions["a" /* default */]).withConfig({
  displayName: "PaymentOptions__Component",
  componentId: "uz6abj-0"
})(["float:left;width:100%;background:", ";@media ", "{justify-content:flex-start;padding-top:", "px;width:", "px;}@media ", "{float:left;justify-content:flex-start;flex-wrap:wrap;height:", "px;img{flex-basis:auto;padding:", "px 0;margin:0;&:nth-child(2){margin-right:", "px;margin-left:", "px;}}}"], theme["a" /* default */].colors.white, theme["a" /* default */].breakpoints.tablet, theme["a" /* default */].baseline * 3, theme["a" /* default */].halfBaseline * 11, theme["a" /* default */].breakpoints.desktop, theme["a" /* default */].baseline * 7, theme["a" /* default */].halfBaseline * 3, theme["a" /* default */].halfBaseline * 3, theme["a" /* default */].halfBaseline * 3);
/* harmony default export */ var Checkout_PaymentOptions = (PaymentOptions_Component);
// CONCATENATED MODULE: ./components/shared/Cart/WideCart/Checkout/CartCheckout/index.js


var CartCheckout = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CartCheckout",
  componentId: "cpqa6q-0"
})(["width:100%;position:relative;bottom:0;background:", ";> div{box-shadow:none;&:after{content:'';display:table;clear:both;}}@media ", "{flex-flow:column;}@media ", "{width:", "px;float:left;}@media ", "{width:", "px;> div{padding-top:0;}}"], function (props) {
  return props.bgWhite ? theme["a" /* default */].colors.white : theme["a" /* default */].colors.black;
}, theme["a" /* default */].breakpoints.tablet, theme["a" /* default */].breakpoints.desktop, theme["a" /* default */].baseline * 18, theme["a" /* default */].breakpoints.desktopLarge, theme["a" /* default */].baseline * 25);
/* harmony default export */ var Checkout_CartCheckout = (CartCheckout);
// CONCATENATED MODULE: ./components/shared/Cart/WideCart/Checkout/Blocks/index.js


var Block = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Blocks__Block",
  componentId: "b0jm2c-0"
})(["width:50%;float:left;display:flex;flex-flow:column;> div{width:100%;padding:0;margin:0;}@media ", "{width:100%;height:auto;}"], theme["a" /* default */].breakpoints.desktop);
var BlockDesc = Object(styled_components_browser_esm["default"])(Block).withConfig({
  displayName: "Blocks__BlockDesc",
  componentId: "b0jm2c-1"
})(["align-items:flex-start;> div{width:100%;padding:0;margin:0;margin-bottom:", "px;&:last-child{margin-bottom:0px;}}"], theme["a" /* default */].baseline * 2);
var BlockCheckout = Object(styled_components_browser_esm["default"])(Block).withConfig({
  displayName: "Blocks__BlockCheckout",
  componentId: "b0jm2c-2"
})(["align-items:flex-end;@media ", "{margin-top:", "px;}@media ", "{margin-top:", "px;}"], theme["a" /* default */].breakpoints.desktop, theme["a" /* default */].baseline * 5, theme["a" /* default */].breakpoints.desktopLarge, theme["a" /* default */].baseline * 7);

// CONCATENATED MODULE: ./components/shared/Cart/WideCart/Checkout/Component.js
var Checkout_Component_jsx = react_default.a.createElement;











var Component_Checkout = function Checkout(_ref) {
  var bgWhite = _ref.bgWhite,
      consentChecked = _ref.consentChecked,
      isConsentRequired = _ref.isConsentRequired,
      loadingCheckout = _ref.loadingCheckout,
      onCheckoutClick = _ref.onCheckoutClick,
      onConsentChange = _ref.onConsentChange,
      pricesIncludeVAT = _ref.pricesIncludeVAT,
      regionId = _ref.regionId,
      totalPrice = _ref.totalPrice;
  return /*#__PURE__*/react_default.a.createElement(Checkout_CartCheckout, {
    bgWhite: bgWhite
  }, /*#__PURE__*/react_default.a.createElement(Checkout_Component_Wrapper, {
    bgWhite: bgWhite
  }, /*#__PURE__*/react_default.a.createElement(BlockDesc, null, /*#__PURE__*/react_default.a.createElement(Checkout_CartPrice, {
    totalPrice: totalPrice,
    pricesIncludeVAT: pricesIncludeVAT
  }), /*#__PURE__*/react_default.a.createElement(shared_ShippingText, null), /*#__PURE__*/react_default.a.createElement(Checkout_PaymentOptions, null)), /*#__PURE__*/react_default.a.createElement(BlockCheckout, null, /*#__PURE__*/react_default.a.createElement(Checkout_CartButtons, {
    onCheckoutClick: onCheckoutClick,
    checkoutLoading: loadingCheckout
  }), isConsentRequired && /*#__PURE__*/react_default.a.createElement(StyledConsent, {
    checkboxId: "cartPage-desktop__checkbox--consent",
    regionId: regionId,
    bgWhite: bgWhite,
    onChange: onConsentChange,
    consentChecked: consentChecked
  }))));
};

var Checkout_Component_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Component__Wrapper",
  componentId: "sc-18gmf8d-0"
})(["padding-top:", "px;"], theme["a" /* default */].halfBaseline * 5);
var StyledConsent = Object(styled_components_browser_esm["default"])(Consent["a" /* default */]).withConfig({
  displayName: "Component__StyledConsent",
  componentId: "sc-18gmf8d-1"
})(["@media ", "{> div{display:flex;justify-content:flex-end;}}@media ", "{display:flex;flex-flow:column-reverse;> div{margin-bottom:", "px;justify-content:flex-start;align-items:flex-start;label{padding-left:", "px;}}}"], theme["a" /* default */].breakpoints.tablet, theme["a" /* default */].breakpoints.desktop, theme["a" /* default */].halfBaseline * 3, theme["a" /* default */].baseline);
Component_Checkout.defaultProps = {
  bgWhite: true
};
/* harmony default export */ var Checkout_Component = (Component_Checkout);
// CONCATENATED MODULE: ./components/shared/Cart/WideCart/Checkout/Container.js
var Checkout_Container_jsx = react_default.a.createElement;










var Container_ConnectedCheckoutContainer = function ConnectedCheckoutContainer(_ref) {
  var totalPrice = _ref.totalPrice,
      handleCheckoutClick = _ref.handleCheckoutClick,
      pricesIncludeVAT = _ref.pricesIncludeVAT,
      loadingCheckout = _ref.loadingCheckout,
      bgWhite = _ref.bgWhite,
      regionId = _ref.regionId,
      showNotification = _ref.showNotification;
  // List of countries that does not require user consent
  var nonComplianceRegions = ['na']; // Set consent required if current region is not in the list

  var isConsentRequired = !nonComplianceRegions.includes(regionId);

  var _useState = Object(react["useState"])(false),
      consentChecked = _useState[0],
      setConsentChecked = _useState[1]; // Set up notice when user click checkout without giving consent


  var onCheckoutClick = isConsentRequired && !consentChecked ? showNotification : handleCheckoutClick; // If region change, set consent value to default

  Object(react["useEffect"])(function () {
    setConsentChecked(false);
  }, [regionId]);
  return /*#__PURE__*/react_default.a.createElement(Checkout_Component, {
    bgWhite: bgWhite,
    consentChecked: consentChecked,
    isConsentRequired: isConsentRequired,
    loadingCheckout: loadingCheckout,
    onCheckoutClick: onCheckoutClick,
    onConsentChange: function onConsentChange() {
      return setConsentChecked(!consentChecked);
    },
    pricesIncludeVAT: pricesIncludeVAT,
    regionId: regionId,
    totalPrice: totalPrice
  });
}; // PropTypes


Container_ConnectedCheckoutContainer.defaultProps = {
  bgWhite: false
};
/**
 * mapStateToProps
 *
 * @param {Object} state Redux state
 * @returns {Object} Props
 */

var Checkout_Container_mapStateToProps = function mapStateToProps(state) {
  var _state$entities = state.entities,
      cartItems = _state$entities.cartItems,
      variants = _state$entities.variants;
  var _state$settings = state.settings,
      regionId = _state$settings.regionId,
      currencyCode = _state$settings.currencyId;
  var shopId = regions_default.a.byId[regionId].shopId;
  var loadingCheckout = state.loading.checkout;
  var _shops$byId$shopId = shops_default.a.byId[shopId],
      pricesIncludeVAT = _shops$byId$shopId.pricesIncludeVAT,
      shopCurrencyCode = _shops$byId$shopId.currencyId;
  var cartItem;
  var price; // Calculate total price

  var totalPrice = cartItems.allIds.reduce(function (acc, cartItemId) {
    cartItem = cartItems.byId[cartItemId];
    price = parseFloat(variants.byId[cartItem.variantId].price);
    return acc + cartItem.quantity * Object(convertToCurrency["a" /* default */])(price, shopCurrencyCode, currencyCode);
  }, 0);
  return {
    totalPrice: totalPrice,
    pricesIncludeVAT: pricesIncludeVAT,
    currencyCode: currencyCode,
    loadingCheckout: loadingCheckout,
    regionId: regionId
  };
};
/**
 * mapDispatchToProps
 *
 * @param {Function} dispatch
 * @returns {Object}
 */


var Checkout_Container_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleCheckoutClick: function handleCheckoutClick() {
      dispatch(Object(handleCheckoutProcess["a" /* default */])());
    },
    showNotification: function showNotification() {
      var errMessage =
      /*i18n*/
      {
        id: "To proceed, agree with the terms and conditions."
      };
      dispatch(Object(handleNotification["a" /* default */])(types["b" /* ERROR */], errMessage, 3));
    }
  };
}; // Connect to redux state


var CheckoutContainer = Object(es["b" /* connect */])(Checkout_Container_mapStateToProps, Checkout_Container_mapDispatchToProps)(Container_ConnectedCheckoutContainer);
/* harmony default export */ var Checkout_Container = (CheckoutContainer);
// CONCATENATED MODULE: ./components/shared/Cart/WideCart/Checkout/index.js

/* harmony default export */ var WideCart_Checkout = (Checkout_Container);
// CONCATENATED MODULE: ./components/shared/Cart/WideCart/CartHeader/CartHeader/index.js

var CartHeader_CartHeader = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CartHeader",
  componentId: "tbo5of-0"
})(["display:none;visibility:hidden;position:relative;@media ", "{display:block;visibility:visible;width:100%;height:", "px;}@media ", "{height:", "px;}"], function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.halfBaseline * 5;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.halfBaseline * 8;
});
/* harmony default export */ var WideCart_CartHeader_CartHeader = (CartHeader_CartHeader);
// CONCATENATED MODULE: ./components/shared/Cart/WideCart/CartHeader/CartHeaderBlock/index.js

var CartHeaderBlock = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CartHeaderBlock",
  componentId: "sc-1k2a6yq-0"
})(["float:left;width:", ";display:flex;@media ", "{width:", ";}"], function (props) {
  return props.w ? props.w[0] : 'auto';
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.w ? props.w[3] : 'auto';
});
/* harmony default export */ var CartHeader_CartHeaderBlock = (CartHeaderBlock);
// CONCATENATED MODULE: ./components/shared/Cart/WideCart/CartHeader/CartHeaderText/index.js


var CartHeaderText = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CartHeaderText",
  componentId: "sc-8ezewg-0"
})(["", " color:", ";font-size:", "px;text-transform:uppercase;font-weight:", ";margin:", ";width:", ";"], bodyTextMixins["d" /* bodyTextMixin4 */], function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.baseline * 2;
}, function (props) {
  return props.bold ? 'bold' : 'normal';
}, function (props) {
  return props.m ? props.m[0] : 0;
}, function (props) {
  return props.w ? props.w[0] : 'auto';
});
/* harmony default export */ var CartHeader_CartHeaderText = (CartHeaderText);
// CONCATENATED MODULE: ./components/shared/Cart/WideCart/CartHeader/Component.js
var CartHeader_Component_jsx = react_default.a.createElement;




 // CartHeader

var Component_CartHeader = function CartHeader(_ref) {
  var numOfItems = _ref.numOfItems;
  return /*#__PURE__*/react_default.a.createElement(WideCart_CartHeader_CartHeader, null, /*#__PURE__*/react_default.a.createElement(CartHeader_CartHeaderBlock, {
    w: ['137px', '', '', '137px']
  }, /*#__PURE__*/react_default.a.createElement(CartHeader_CartHeaderText, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Items"
  }), " (", numOfItems, "):")), /*#__PURE__*/react_default.a.createElement(CartHeader_CartHeaderBlock, {
    w: ['calc(100% - 137px - 32px)', '', '', 'calc(100% - 137px - 60px)']
  }, /*#__PURE__*/react_default.a.createElement(CartHeader_CartHeaderText, {
    w: ['52%']
  }), /*#__PURE__*/react_default.a.createElement(CartHeader_CartHeaderText, {
    w: ['22%']
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Quantity"
  }), ":"), /*#__PURE__*/react_default.a.createElement(CartHeader_CartHeaderText, {
    w: ['26%']
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Price"
  }), ":")));
}; // PropTypes


/* harmony default export */ var CartHeader_Component = (Component_CartHeader);
// CONCATENATED MODULE: ./components/shared/Cart/WideCart/CartHeader/Container.js
var CartHeader_Container_jsx = react_default.a.createElement;




var Container_ConnectedCartHeaderContainer = function ConnectedCartHeaderContainer(_ref) {
  var numOfItems = _ref.numOfItems;
  return /*#__PURE__*/react_default.a.createElement(CartHeader_Component, {
    numOfItems: numOfItems
  });
};

var CartHeader_Container_mapStateToProps = function mapStateToProps(state) {
  var cartItems = state.entities.cartItems;
  var numOfItems = cartItems.allIds.reduce(function (acc, cartItemId) {
    return acc + cartItems.byId[cartItemId].quantity;
  }, 0);
  return {
    numOfItems: numOfItems
  };
}; // Connect to redux state


var CartHeaderContainer = Object(es["b" /* connect */])(CartHeader_Container_mapStateToProps)(Container_ConnectedCartHeaderContainer);
/* harmony default export */ var CartHeader_Container = (CartHeaderContainer);
// CONCATENATED MODULE: ./components/shared/Cart/WideCart/CartHeader/index.js

/* harmony default export */ var WideCart_CartHeader = (CartHeader_Container);
// CONCATENATED MODULE: ./components/shared/Cart/WideCart/Component.js

var WideCart_Component_jsx = react_default.a.createElement;





 // Items

var Component_Items = function Items(_ref) {
  var cartItemIds = _ref.cartItemIds,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["cartItemIds"]);

  return /*#__PURE__*/react_default.a.createElement(ItemsWrapper, null, /*#__PURE__*/react_default.a.createElement(ItemsList, null, /*#__PURE__*/react_default.a.createElement(WideCart_CartHeader, null), /*#__PURE__*/react_default.a.createElement(StyledItems, {
    className: rest.className
  }, cartItemIds.map(function (cartItemId) {
    return /*#__PURE__*/react_default.a.createElement(CartItem, {
      key: cartItemId,
      cartItemId: cartItemId
    });
  }), /*#__PURE__*/react_default.a.createElement(UpsellExtraBattery, null))), /*#__PURE__*/react_default.a.createElement(WideCart_Checkout, {
    bgWhite: rest.bgWhite
  }));
}; // PropTypes


// StyledItems
var StyledItems = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "Component__StyledItems",
  componentId: "sc-1ds8buf-0"
})(["padding:0;margin:0;width:100%;"]);
var ItemsWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Component__ItemsWrapper",
  componentId: "sc-1ds8buf-1"
})(["display:none;@media ", "{display:flex;flex-flow:column;}@media ", "{flex-flow:row;justify-content:space-between;}"], function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.breakpoints.desktop;
});
var ItemsList = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Component__ItemsList",
  componentId: "sc-1ds8buf-2"
})(["display:flex;flex-flow:column;@media ", "{display:block;width:700px;float:left;}@media ", "{width:970px;}"], function (props) {
  return props.theme.breakpoints.desktop;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
});
/* harmony default export */ var WideCart_Component = (Component_Items);
// CONCATENATED MODULE: ./components/shared/Cart/WideCart/Container.js

var WideCart_Container_jsx = react_default.a.createElement;


 // Container

var Container_ConnectedItemsContainer = function ConnectedItemsContainer(_ref) {
  var cartItemIds = _ref.cartItemIds,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["cartItemIds"]);

  return /*#__PURE__*/react_default.a.createElement(WideCart_Component, {
    className: rest.className,
    cartItemIds: cartItemIds,
    bgWhite: rest.bgWhite
  });
}; // PropTypes


// MapStateToProps
var WideCart_Container_mapStateToProps = function mapStateToProps(state) {
  return {
    cartItemIds: state.entities.cartItems.allIds
  };
}; // Connect


var ItemsContainer = Object(es["b" /* connect */])(WideCart_Container_mapStateToProps)(Container_ConnectedItemsContainer);
/* harmony default export */ var WideCart_Container = (ItemsContainer);
// CONCATENATED MODULE: ./components/shared/Cart/WideCart/index.js

/* harmony default export */ var WideCart = (WideCart_Container);
// EXTERNAL MODULE: ./actions/toggleCartDrawer.js
var toggleCartDrawer = __webpack_require__("HDjz");

// EXTERNAL MODULE: ./components/shared/Row/index.js
var Row = __webpack_require__("OfJt");

// CONCATENATED MODULE: ./components/shared/Cart/EmptyCart/Text/index.js


var styledNarrowText = Object(styled_components_browser_esm["css"])(["@media ", "{font-size:", "px;}@media ", "{font-size:", "px;}"], function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.halfBaseline * 9;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.halfBaseline * 13;
});
var Text_Text = Object(styled_components_browser_esm["default"])(Text["g" /* Highlight1 */]).withConfig({
  displayName: "Text",
  componentId: "bgek9f-0"
})(["", ";"], function (props) {
  return props.narrow && styledNarrowText;
});
/* harmony default export */ var EmptyCart_Text = (Text_Text);
// CONCATENATED MODULE: ./components/shared/Cart/EmptyCart/index.js
var EmptyCart_jsx = react_default.a.createElement;









var narrowEmptyCart = Object(styled_components_browser_esm["css"])(["@media ", "{width:", "px;div a{margin-right:0;}}"], function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.baseline * 35;
}); // Wrapper

var EmptyCart_Wrapper = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "EmptyCart__Wrapper",
  componentId: "zpc8lx-0"
})(["text-align:center;height:100%;display:flex;flex-flow:column;align-items:center;justify-content:center;> div{margin:", ";}", ";"], function (props) {
  return props.theme.space.stack.l;
}, function (props) {
  return props.narrow && narrowEmptyCart;
}); // EmptyCart

var EmptyCart_EmptyCart = function EmptyCart(_ref) {
  var narrow = _ref.narrow,
      handleShopClick = _ref.handleShopClick;
  return /*#__PURE__*/react_default.a.createElement(EmptyCart_Wrapper, {
    narrow: narrow
  }, /*#__PURE__*/react_default.a.createElement(EmptyCart_Text, {
    narrow: narrow
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Your cart is empty."
  })), /*#__PURE__*/react_default.a.createElement(Button["a" /* ButtonRow */], {
    center: true
  }, /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: "/products",
    passHref: true
  }, /*#__PURE__*/react_default.a.createElement(Button["e" /* StandardButton */], {
    id: "cart-empty__button--shop",
    fixedWidth: true,
    onClick: handleShopClick
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BUY"
  }))), /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: "/products/soundboks-gen-3",
    passHref: true
  }, /*#__PURE__*/react_default.a.createElement(Button["e" /* StandardButton */], {
    id: "cart-empty__button--nsb"
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.soundboksGen3.header"
  })))));
};

EmptyCart_EmptyCart.defaultProps = {
  narrow: false
};

// mapDispatchToProps
var EmptyCart_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleShopClick: function handleShopClick() {
      dispatch(Object(toggleCartDrawer["a" /* default */])());
    }
  };
};

/* harmony default export */ var Cart_EmptyCart = (Object(es["b" /* connect */])(null, EmptyCart_mapDispatchToProps)(EmptyCart_EmptyCart));
// CONCATENATED MODULE: ./components/shared/Cart/index.js





/***/ }),

/***/ "hxB5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./data/regions.js
var regions = __webpack_require__("keR7");
var regions_default = /*#__PURE__*/__webpack_require__.n(regions);

// EXTERNAL MODULE: ./data/shops.js
var shops = __webpack_require__("z1id");
var shops_default = /*#__PURE__*/__webpack_require__.n(shops);

// EXTERNAL MODULE: ./data/currencies.js
var currencies = __webpack_require__("BP0X");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./components/shared/Price/index.js + 2 modules
var Price = __webpack_require__("5Aug");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Skeleton/index.tsx
var Skeleton = __webpack_require__("OWaX");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/styles/theme.ts
var theme = __webpack_require__("isV7");

// CONCATENATED MODULE: ./components/shared/Cart/shared/TotalPrice/Component.js
var __jsx = react_default.a.createElement;

// import { NumberFormat } from '@lingui/macro';


 // TotalPrice

var Component_TotalPrice = function TotalPrice(_ref) {
  var totalPrice = _ref.totalPrice,
      currencyCode = _ref.currencyCode,
      showLocal = _ref.showLocal,
      className = _ref.className;
  return /*#__PURE__*/react_default.a.createElement("div", {
    className: className
  }, /*#__PURE__*/react_default.a.createElement("div", null, totalPrice ? /*#__PURE__*/react_default.a.createElement(Price["b" /* RegionPrice */], {
    price: totalPrice,
    currencyId: currencyCode
  }) : /*#__PURE__*/react_default.a.createElement(Skeleton["a" /* Skeleton */], {
    width: theme["j" /* Size */].BaseUnit * 12,
    height: theme["j" /* Size */].BaseUnit * 3
  })), showLocal && /*#__PURE__*/react_default.a.createElement(Price["a" /* LocalPrice */], {
    price: totalPrice
  }));
}; // PropTypes


Component_TotalPrice.defaultProps = {
  showLocal: false,
  className: null
};
/* harmony default export */ var Component = (Component_TotalPrice);
// CONCATENATED MODULE: ./components/shared/Cart/shared/TotalPrice/Container.js





/**
 * mapStateToProps
 *
 * @param {Object} state Redux state
 * @returns {Object} Props
 */

var Container_mapStateToProps = function mapStateToProps(state, props) {
  var cartItems = state.entities.cartItems;
  var dynamicVariants = props.dynamicVariants;
  var regionId = state.settings.regionId;
  var shopId = regions_default.a.byId[regionId].shopId;
  var currencyId = shops_default.a.byId[shopId].currencyId;
  var cartItem;
  var price; // Calculate total price from cart items

  var totalPrice = cartItems.allIds.reduce(function (acc, cartItemId) {
    var _dynamicVariants$byId;

    cartItem = cartItems.byId[cartItemId];
    var variantPrice = (_dynamicVariants$byId = dynamicVariants.byId[cartItem.variantId]) === null || _dynamicVariants$byId === void 0 ? void 0 : _dynamicVariants$byId.price;
    price = parseFloat(variantPrice);
    return acc + cartItem.quantity * price;
  }, 0);
  return {
    totalPrice: totalPrice,
    currencyCode: currencies["a" /* default */].byId[currencyId].code
  };
}; // Connect to redux state


var TotalPriceContainer = Object(es["b" /* connect */])(Container_mapStateToProps)(Component);
/* harmony default export */ var Container = (TotalPriceContainer);
// CONCATENATED MODULE: ./components/shared/Cart/shared/TotalPrice/index.js

/* harmony default export */ var shared_TotalPrice = __webpack_exports__["a"] = (Container);

/***/ }),

/***/ "ohNE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ layout_Row; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ layout_Wrapper; });

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./styles/theme.js
var theme = __webpack_require__("NVT0");

// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/Checkout/layout/Row.js


var Row = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Row",
  componentId: "sc-1enhi9p-0"
})(["display:grid;grid-template-columns:1fr 1fr;column-gap:", "px;padding:0 ", "px;@media ", "{column-gap:20px;padding:0 40px;}"], theme["a" /* default */].baseline, theme["a" /* default */].baseline * 2, theme["a" /* default */].breakpoints.desktopLarge);
/* harmony default export */ var layout_Row = (Row);
// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/Checkout/layout/Wrapper.js


var Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-10k9g4l-0"
})(["padding-top:", "px;box-shadow:", ";@media ", "{padding-top:", "px;}"], theme["a" /* default */].halfBaseline * 5, function (_ref) {
  var bgWhite = _ref.bgWhite;
  return bgWhite ? '0 -1px 1px 0 rgba(0,0,0,0.08)' : theme["a" /* default */].shadows.standard;
}, theme["a" /* default */].breakpoints.desktopLarge, theme["a" /* default */].halfBaseline * 8);
/* harmony default export */ var layout_Wrapper = (Wrapper);
// CONCATENATED MODULE: ./components/shared/Cart/NarrowCart/Checkout/layout/index.js




/***/ }),

/***/ "uAAP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("vOnD");
/* harmony import */ var styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("NVT0");
/* harmony import */ var _images_icons_maestro_grey_png_placeholder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("RN8+");
/* harmony import */ var _images_icons_maestro_grey_png_placeholder__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_images_icons_maestro_grey_png_placeholder__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _images_icons_mastercard_grey_png_placeholder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CJuD");
/* harmony import */ var _images_icons_mastercard_grey_png_placeholder__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_images_icons_mastercard_grey_png_placeholder__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _images_icons_visa_grey_png_placeholder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("a7li");
/* harmony import */ var _images_icons_visa_grey_png_placeholder__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_images_icons_visa_grey_png_placeholder__WEBPACK_IMPORTED_MODULE_5__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







var PaymentOptions = function PaymentOptions(_ref) {
  var className = _ref.className,
      bgWhite = _ref.bgWhite;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StyledPaymentOptions, {
    bgWhite: bgWhite,
    className: className
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(PaymentProvider, {
    src: _images_icons_visa_grey_png_placeholder__WEBPACK_IMPORTED_MODULE_5___default.a.url,
    alt: "Visa"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(PaymentProvider, {
    src: _images_icons_maestro_grey_png_placeholder__WEBPACK_IMPORTED_MODULE_3___default.a.url,
    alt: "Maestro"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(PaymentProvider, {
    src: _images_icons_mastercard_grey_png_placeholder__WEBPACK_IMPORTED_MODULE_4___default.a.url,
    alt: "Mastercard"
  }));
};

var StyledPaymentOptions = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
  displayName: "PaymentOptions__StyledPaymentOptions",
  componentId: "sc-1eogpgg-0"
})(["height:", "px;background:", ";display:flex;justify-content:center;"], styles_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].halfBaseline * 13, styles_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].colors.black2);
var PaymentProvider = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].img.withConfig({
  displayName: "PaymentOptions__PaymentProvider",
  componentId: "sc-1eogpgg-1"
})(["width:", "px;object-fit:contain;margin:0 ", "px;"], styles_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].baseline * 5, styles_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].baseline);
PaymentOptions.defaultProps = {
  bgWhite: false,
  className: null
};
/* harmony default export */ __webpack_exports__["a"] = (PaymentOptions);

/***/ }),

/***/ "vcXL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* globals self */var fetch=self.fetch.bind(self);module.exports=fetch;module.exports.default=module.exports;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "x4ww":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogIzIxMjIyMjsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPGcgaWQ9Ikdyb3VwXzIzMzgiIGRhdGEtbmFtZT0iR3JvdXAgMjMzOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTg5OCAtMzA0LjUpIj4KICAgIDxnIGlkPSJHcm91cF8yMzM2IiBkYXRhLW5hbWU9Ikdyb3VwIDIzMzYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02IC0yKSI+CiAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTY5NiIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMTY5NiIgY2xhc3M9ImNscy0xIiB3aWR0aD0iMyIgaGVpZ2h0PSIxMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTA0IDMxNCkgcm90YXRlKC05MCkiLz4KICAgIDwvZz4KICAgIDxnIGlkPSJHcm91cF8yMzM3IiBkYXRhLW5hbWU9Ikdyb3VwIDIzMzciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU5MS41IDEyMjAuNSkgcm90YXRlKC05MCkiPgogICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzE2OTYtMiIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMTY5NiIgY2xhc3M9ImNscy0xIiB3aWR0aD0iMyIgaGVpZ2h0PSIxMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTA0IDMxNCkgcm90YXRlKC05MCkiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=" };

/***/ }),

/***/ "yFDH":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAzIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjMjEyMjIyOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8ZyBpZD0iR3JvdXBfMjI4OCIgZGF0YS1uYW1lPSJHcm91cCAyMjg4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOTA0IC0zMTEpIj4KICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTY5NiIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMTY5NiIgY2xhc3M9ImNscy0xIiB3aWR0aD0iMyIgaGVpZ2h0PSIxMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTA0IDMxNCkgcm90YXRlKC05MCkiLz4KICA8L2c+Cjwvc3ZnPgo=" };

/***/ })

}]);